import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { getPreInvoices, showPreInvoice, createPreInvoice, editPreInvoice } from '../../controllers/api_pre_invoices'; // Importa el servicio
import { showInvoice } from '../../controllers/api_invoices'; // Importa el servicio
import { getProducts, showProduct, createProduct } from '../../controllers/apiProducts'; // Importa el servicio
import { getEndClients, showEndClient, createEndClient } from '../../controllers/api_end_clients'; // Importa el servicio
import { getClients, showClient, normalizeClientsResponse } from '../../controllers/api_clients';
import { getPaymentMethods } from '../../controllers/api_payment_methods';
import { getLatestExchangeRateHistory } from '../../controllers/api_exchange_rate_history';
import { getMonedas, normalizeMonedasResponse, getTiposVenta } from '../../controllers/api_monedas';
import { useNavigate } from "react-router-dom"; // Para la redirección
import { decryptText } from '../../controllers/api'; // Importa el servicio para encriptar/desencriptar parametros
import { useLocation } from "react-router-dom"; // Para la obtener el parametro de la url
import { toast, ToastContainer } from "react-toastify"; // Importamos las funciones necesarias
import "react-toastify/dist/ReactToastify.css"; // Importar el CSS de las notificaciones
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { Button } from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import { Tabs, Tab, Box } from "@mui/material";
import { esES } from '@mui/x-data-grid/locales';
import $ from "jquery";
import { formatDecimal, formatMoney, formatDate, formatDateTime, formatText, validateFormatEmail, validateFormatPhone, validateFormatRif, formatMoneySpecial } from "../../utils/formatters";
import { FORM_FOOTER_CONTAINER, FORM_BTN_CANCEL, FORM_BTN_SUBMIT } from "../../utils/formHelpers";
// (2026-07-22 Viajes) Fuente única de los 15 campos del nodo `/viajes`.
import { VIAJE_CAMPOS, nuevoViajeVacio, viajeTieneDatos } from "../../utils/viajeCampos";

// =============================================================================
// (2026-08-02, ítems 29-ii / 30-ii / 34) Helpers PUROS a nivel de módulo.
//
// Viven fuera del componente y sin JSX a propósito: son la fuente ÚNICA de las
// reglas que este formulario tiene que espejar del backend (precedencia del
// descuento, total de línea, coherencia de fechas, modo de operación), y la
// suite src/utils/__tests__/proformas_calculos.test.js las extrae VERBATIM de
// este archivo — si la regla cambia aquí, la prueba corre con el cambio.
// =============================================================================

// Modo de operación del EMISOR (empresas.tipo_operacion, models.py:223).
// 'NumeracionAutomatica' -> el sistema asigna el consecutivo; el correlativo
// interno del ERP no se pide ni se valida (el backend TAMPOCO lo exige:
// factura_routes.py:827-835; solo lo compara al EMITIR en ValidacionDocumento,
// utils_correlativo.py:206-218).
export const MODO_NUMERACION_AUTOMATICA = 'NumeracionAutomatica';

export const esModoNumeracionAutomatica = (modo) => {
  if (modo === undefined || modo === null) return false;
  return String(modo).trim().toLowerCase() === 'numeracionautomatica';
};

// Tipo de descuento EFECTIVO de una línea. Es EXCLUYENTE por decisión de la
// ronda, porque el backend da PRECEDENCIA al porcentaje cuando no es NULL
// (utils.py:565-575): si se enviaran los dos, el monto se perdería en silencio.
// Cuando la línea NO trae la marca `descuento_tipo` el tipo se DERIVA del dato
// con la misma regla del backend (precedencia del %): porcentaje NULL + monto
// > 0 => la línea es de monto fijo. Hace falta de verdad: la ruta de CREACIÓN de
// proforma (factura_routes.py:1660-1680) no persiste `descuento_tipo`, y las
// líneas que entran por la API de integración tampoco tienen por qué mandarlo.
// Sin esta derivación, al reabrir una proforma con descuento por monto la UI la
// leería como "porcentaje 0" y al guardar BORRARÍA el descuento.
export const tipoDescuentoLinea = (item) => {
  if (!item) return 'porcentaje';
  const marca = String(item.descuento_tipo || '').toLowerCase();
  if (marca === 'monto') return 'monto';
  if (marca === 'porcentaje') return 'porcentaje';
  const pct = item.descuento_porcentaje;
  const pctVacio = (pct === undefined || pct === null || pct === '');
  if (pctVacio && (Number(item.descuento_monto) || 0) > 0) return 'monto';
  return 'porcentaje';
};

// Descuento efectivo de la línea, en la moneda de la proforma.
export const descuentoLineaProforma = (item) => {
  if (!item) return 0;
  const cantidad = Number(item.cantidad) || 0;
  const precio = Number(item.precio_unitario) || 0;
  const subtotal = cantidad * precio;
  if (tipoDescuentoLinea(item) === 'monto') {
    return Number(item.descuento_monto) || 0;
  }
  return subtotal * ((Number(item.descuento_porcentaje) || 0) / 100);
};

// Base de la línea (sin IVA) — ESPEJO de utils.validar_y_recalcular_prefactura:
//   precioItem = cantidad*precio - descuento(% Ó monto) + recargo_monto
// El recargo se SUMA y NO se acota; el descuento por monto sí se acota al
// subtotal (lo valida validate(), espejo de utils.py:573-575).
//
// (H8, auditoría 2026-08-02) DERIVA DE REDONDEO conocida y ACEPTADA: aquí se
// redondea con `Math.round(x*100)/100` sobre binario IEEE-754, mientras el
// backend usa `Decimal.quantize(0.01, ROUND_HALF_UP)`. En los medios exactos
// (…,xx5) los dos pueden diferir en 1 céntimo. MITIGANTE, no parche: el
// SERVIDOR ES LA FUENTE DE VERDAD — recalcula todos los montos e ignora los
// totales que mande el cliente (memoria `feedback_fuente_verdad_montos`), así
// que este número es orientativo para la pantalla y para el cuadre de pagos,
// que ya absorbe hasta 0,05 de tolerancia en validate(). Lo que NUNCA debe
// diferir es la FÓRMULA (qué se resta y qué se suma), y de eso sí responde la
// suite de tests.
export const totalLineaProforma = (item) => {
  if (!item) return 0;
  const cantidad = Number(item.cantidad) || 0;
  const precio = Number(item.precio_unitario) || 0;
  const recargo = Number(item.recargo_monto) || 0;
  const total = (cantidad * precio) - descuentoLineaProforma(item) + recargo;
  return Math.round(total * 100) / 100;
};

// Normalización del descuento PARA EL PAYLOAD (exclusividad real en el cable).
// En modo 'monto' `descuento_porcentaje` viaja como NULL — no como 0 — porque un
// 0 explícito DESACTIVA el camino del monto en el backend (utils.py:565) y
// `descuento_porcentaje` está deliberadamente FUERA de la coerción ''|null -> 0
// (servicios_compartidos.py:47-55). Enviar 0 aquí perdería el descuento.
export const normalizarDescuentoPayload = (item) => {
  if (tipoDescuentoLinea(item) === 'monto') {
    return {
      descuento_porcentaje: null,
      descuento_monto: Number(item.descuento_monto) || 0,
    };
  }
  return {
    descuento_porcentaje: Number(item.descuento_porcentaje) || 0,
    descuento_monto: 0,
  };
};

// Aplica la normalización a TODA la lista de ítems justo antes de enviarla.
// Está extraída del `handleSubmit` a propósito: es el CABLEADO lo que puede
// romperse (que alguien quite el bucle y vuelva a mandar las dos columnas con
// valor), y así la suite puede probar el efecto real sobre una lista.
// Muta la lista recibida (es la misma que viaja en el body) y la devuelve.
export const aplicarDescuentoPayloadItems = (items) => {
  const lista = Array.isArray(items) ? items : [];
  for (let i = 0; i < lista.length; i++) {
    const it = lista[i];
    if (!it || typeof it !== 'object') continue;
    const d = normalizarDescuentoPayload(it);
    it.descuento_porcentaje = d.descuento_porcentaje;
    it.descuento_monto = d.descuento_monto;
    if (!it.descuento_nombre) it.descuento_nombre = null;
    // (2026-08-02, remediación H5) `descuento_tipo` NO se envía: es un campo
    // SOLO DE PANTALLA. No existe en el backend (0 ocurrencias en
    // optimus_invoice/). Si alguna vez llegara a la BD sería basura silenciosa.
    //
    // ⚠️ NO "corregirlo" a `tipo_descuento`, que sí existe (models.py:701): ese
    // campo legacy alimenta `descuento_nombre` al convertir la proforma en
    // factura (factura_routes.py:2337-2341) y de ahí sale `descDescuento` /
    // `descripcionBonificacion` del documento electrónico — mandar aquí
    // 'porcentaje'/'monto' publicaría esas cadenas en el XML del SENIAT.
    // La reapertura de la proforma no lo necesita: `tipoDescuentoLinea` deriva
    // el modo del propio dato (% NULL + monto > 0 = monto).
    if ('descuento_tipo' in it) delete it.descuento_tipo;
    // (2026-08-03, P4/T3) Línea de comisión de tercero (regla COMBINADA). Dos
    // campos DISTINTOS que no hay que confundir:
    //
    //  - `es_comision_tercero`: CONTRATO DE API — SÍ viaja. Es la 3ª vía de
    //    identificación de `factura_routes._es_linea_comision`, y la única
    //    utilizable desde la web: con `doc_tercero` activo el catálogo cargado
    //    es el del TERCERO, mientras que el producto de comisión pertenece al
    //    EMISOR, así que la pantalla no siempre puede mandar `producto_id` ni
    //    `producto_sku`. Sin esta marca el backend contaría la línea como una
    //    VENTA más y la comisión se cobraría DOS VECES.
    //    `_normalizar_linea_comision` completa después producto, SKU,
    //    `aplica_iva` e `iva_categoria_id` server-side (la comisión no la
    //    parametriza el cliente).
    //  - `_es_comision`: marca de PANTALLA — NO viaja. Mismo criterio que
    //    `descuento_tipo`: no existe en el backend y sería basura silenciosa.
    //
    // El orden importa: primero se traduce la marca de pantalla al contrato y
    // solo después se borra.
    if (esLineaComisionTercero(it)) it.es_comision_tercero = true;
    if ('_es_comision' in it) delete it._es_comision;
  }
  return lista;
};

// Descuento por MONTO FIJO de una línea — ESPEJO EXACTO de utils.py:569-575.
// Extraída de validate() por la misma razón que la anterior: el tope
// `monto <= subtotal` es una garantía cara y tiene que poder probarse sola.
// Devuelve null si la línea es válida, o el mensaje de error.
export const validarDescuentoMontoLinea = (item) => {
  if (!item) return null;
  if (tipoDescuentoLinea(item) !== 'monto') return null;
  const monto = Number(item.descuento_monto) || 0;
  const subtotal = (Number(item.cantidad) || 0) * (Number(item.precio_unitario) || 0);
  if (monto < 0) {
    return 'No se pueden procesar las lineas con descuento por monto menor que 0.';
  }
  if (monto > subtotal) {
    return 'El descuento por monto no puede ser mayor que el subtotal de la linea.';
  }
  return null;
};

// ── (2026-08-03, P3 Descuentos globales) FACTOR DE PRORRATEO GLOBAL ──────────
// ESPEJO EXACTO de `seniat.serializador._factor_recargo_global`, de
// `utils.validar_y_recalcular_prefactura` y de `seniat.validador._factor_global`:
//
//     factor = (1 − D/SAD) × (1 + R/SAD)
//
// con SAD = Σ base neta de línea (descuento y recargo de LÍNEA ya aplicados),
// D = Σ descuentos GLOBALES y R = Σ recargos GLOBALES. Los descuentos globales
// tienen la proporción INVERSA de los recargos: mismo denominador, signo opuesto.
//
// Se extrae como helper de módulo —igual que `totalLineaProforma`— para que la
// suite pueda probar la fórmula sola: es la garantía cara de esta pantalla, y un
// signo invertido aquí muestra un total equivocado en TODA la proforma.
// Sin SAD (>0) o sin D ni R devuelve 1 (no-op): el cálculo histórico intacto.
export const factorGlobalProrrateo = (sad, descuentoGlobal, recargoGlobal) => {
  const S = Number(sad) || 0;
  const D = Number(descuentoGlobal) || 0;
  const R = Number(recargoGlobal) || 0;
  if (S <= 0 || (D <= 0 && R <= 0)) return 1;
  return (1 - (D / S)) * (1 + (R / S));
};

// Cota del descuento GLOBAL — ESPEJO de la regla del backend
// (utils.validar_y_recalcular_prefactura: `D <= SAD` -> 400). Un descuento global
// mayor que la suma de las bases dejaría bases imponibles NEGATIVAS.
// Devuelve null si es válido, o el mensaje de error.
export const validarDescuentoGlobal = (descuentoGlobal, sad) => {
  const D = Number(descuentoGlobal) || 0;
  const S = Number(sad) || 0;
  if (D < 0) {
    return 'Los descuentos globales no pueden tener monto negativo.';
  }
  if (D > 0 && D > S) {
    return 'El descuento global no puede superar el subtotal de los items: dejaria bases imponibles negativas.';
  }
  return null;
};

// ── (2026-08-03, P4/T3) COMISIÓN DE TERCERO EN REGLA «COMBINADA» ────────────
// Marca de PANTALLA de la línea de comisión. Se centraliza aquí para que la
// detección sea UNA sola (columnas, papelera, processRowUpdate, payload y el
// propio cálculo la comparten) y para que un mutante que la afloje muera en un
// único sitio. NO viaja en el payload (ver `aplicarDescuentoPayloadItems`).
export const esLineaComisionTercero = (item) => {
  return !!(item && item._es_comision);
};

// Remarcado de la línea de comisión al REABRIR una proforma guardada. Sus
// ítems vuelven del backend SIN `_es_comision` (es un campo de pantalla), de
// modo que sin esto la comisión persistida quedaba editable y borrable — justo
// lo contrario de la decisión del usuario.
//
// La identificación se hace por el DATO QUE MANDA EL BACKEND:
// `producto.es_tercero === true` (PrefacturaItemSchema expone el nested
// `producto` con esa clave). NO se usa la resolución del producto de comisión
// contra el catálogo del emisor, que depende de una llamada de red que puede
// fallar: el marcado tiene que ser determinista.
//
// Solo MARCA. No calcula ni crea nada: al reabrir, el importe de la comisión es
// el que ya validó y persistió el servidor.
// Muta la lista recibida (es la que se guarda en el estado) y la devuelve.
export const marcarLineaComisionPersistida = (items) => {
  const lista = Array.isArray(items) ? items : [];
  for (let i = 0; i < lista.length; i++) {
    const it = lista[i];
    if (!it || typeof it !== 'object') continue;
    if (it.producto && it.producto.es_tercero === true) {
      it._es_comision = true;
    }
  }
  return lista;
};

// Monto de la comisión del tercero cuando el EMISOR tiene
// `empresas.regla_facturacion == 'Combinada'` — ESPEJO EXACTO de
// `optimus_invoice/factura_routes.py`, helper `_calcular_comision_aplicada`:
//
//     comision = (base * comision_porcentaje / 100).quantize(Decimal('0.01'))
//
// donde `base` es el `total_base` que devuelve
// `utils.validar_y_recalcular_prefactura(items_SIN_la_linea_de_comision, ...,
// recargo_global_total=R, descuento_global_total=D)`, es decir:
//
//     SAD_otras = Σ (cantidad*precio − descuento_de_línea + recargo_de_línea)
//                 [SOLO las líneas que NO son la comisión]
//     factor    = (1 − D/SAD_otras) × (1 + R/SAD_otras)     [1 si D=0 y R=0]
//     base      = SAD_otras × factor
//     comision  = redondeo(base × pct / 100, 2 decimales)
//
// La comisión NO se calcula sobre sí misma: las líneas `_es_comision` quedan
// FUERA del SAD. Esa es la garantía cara de este helper (si entraran, cada
// recálculo inflaría el monto de forma acumulativa).
//
// Reutiliza `totalLineaProforma` y `factorGlobalProrrateo` a propósito: la
// aritmética no se reimplementa, se COMPONE de los dos helpers ya probados.
//
// DERIVA DE REDONDEO conocida y ACEPTADA (misma doctrina que
// `totalLineaProforma`): aquí se redondea con `Math.round(x*100)/100` sobre
// IEEE-754 y el backend usa `Decimal.quantize(0.01, ROUND_HALF_UP)`; en los
// medios exactos pueden diferir en 1 céntimo. El SERVIDOR ES LA FUENTE DE
// VERDAD — recalcula y valida el monto recibido; este número gobierna la
// pantalla y el cuadre de pagos, que absorbe 0,05 de tolerancia.
export const comisionTerceroCombinada = (items, comisionPorcentaje, descuentoGlobal, recargoGlobal) => {
  const lista = Array.isArray(items) ? items : [];
  const pct = Number(comisionPorcentaje) || 0;
  if (pct <= 0) return 0;
  let sad = 0;
  let propias = 0;
  for (let i = 0; i < lista.length; i++) {
    const it = lista[i];
    if (!it || typeof it !== 'object') continue;
    if (esLineaComisionTercero(it)) continue;
    propias++;
    sad += totalLineaProforma(it);
  }
  if (propias === 0 || sad <= 0) return 0;
  const base = sad * factorGlobalProrrateo(sad, descuentoGlobal, recargoGlobal);
  const comision = (base * pct) / 100;
  return Math.round(comision * 100) / 100;
};

// (ítem 29-ii) Valor de `correlativo_interno` que viaja en el payload.
// En NumeracionAutomatica un correlativo vacío se envía como NULL, NUNCA como
// "": la tabla tiene UNIQUE(empresa_id, correlativo_interno) (models.py:685) y
// la SEGUNDA proforma con "" violaría la restricción (Postgres sí admite N
// NULLs). Un valor ya cargado NO se borra.
export const correlativoParaPayload = (valor, automatico) => {
  if (!automatico) return valor;
  if (valor === undefined || valor === null) return null;
  return String(valor).trim() === '' ? null : valor;
};

// (ítem 34) Coherencia de la Fecha de Vencimiento. El campo es OPCIONAL y su
// vacío SIGNIFICA "contado" (decisión pendiente del usuario: NO se pone un
// default de hoy, que convertiría toda venta de contado en "vence hoy" dentro
// del documento fiscal). Lo que sí se valida: si viene informada debe tener
// formato válido y no ser ANTERIOR a la fecha del documento.
// Devuelve null si es válida, o el mensaje de error.
export const validarFechaVencimiento = (fechaFactura, fechaVencimiento) => {
  const venc = (fechaVencimiento === undefined || fechaVencimiento === null)
    ? '' : String(fechaVencimiento).trim();
  if (venc === '') return null; // vacío = contado: válido.
  if (!/^\d{4}-\d{2}-\d{2}$/.test(venc)) {
    return 'La fecha de vencimiento no tiene un formato válido (AAAA-MM-DD).';
  }
  const [_ay, _am, _ad] = venc.split('-').map(Number);
  const _d = new Date(_ay, _am - 1, _ad);
  if (
    _d.getFullYear() !== _ay || (_d.getMonth() + 1) !== _am || _d.getDate() !== _ad
  ) {
    return 'La fecha de vencimiento no tiene un formato válido (AAAA-MM-DD).';
  }
  const emision = (fechaFactura === undefined || fechaFactura === null)
    ? '' : String(fechaFactura).trim();
  // Sin fecha de documento no hay contra qué comparar (ese error ya lo reporta
  // la validación de `fecha_factura`).
  if (!/^\d{4}-\d{2}-\d{2}$/.test(emision)) return null;
  // Comparación lexicográfica: en formato AAAA-MM-DD equivale a la cronológica
  // y no arrastra la zona horaria de `new Date('YYYY-MM-DD')`.
  if (venc < emision) {
    return 'La fecha de vencimiento no puede ser anterior a la fecha del documento.';
  }
  return null;
};

// Componente editor para el Autocomplete
function ProductoEditCell({ params, products }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // pone el cursor en el buscador
    }
  }, []);

  return (
    <Autocomplete
      options={products || []}
      fullWidth
      size="small"
      getOptionLabel={(option) => `${option.sku} - ${option.nombre}`}
      value={products?.find((p) => p.id === params.value) || null}
      onChange={(event, newValue) => {
        params.api.setEditCellValue({
          id: params.id,
          field: "producto_id",
          value: newValue ? newValue.id : "",
        });
      }}
      renderInput={(p) => (
        <TextField
          {...p}
          inputRef={inputRef} // aquí va el ref para el foco
          variant="standard"
          placeholder="Seleccione un producto/servicio..."
          fullWidth
          InputProps={{
            ...p.InputProps,
            sx: { height: "100%", padding: "0 !important" },
          }}
        />
      )}
      sx={{
        width: "100%",
        height: "100%",
        "& .MuiInputBase-root": {
          height: "100%",
          padding: "0 !important",
          display: "flex",
          alignItems: "center",
        },
      }}
    />
  );
}

function ModoPagoEditCell({ params, paymentMethods }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <Autocomplete
      options={paymentMethods || []}
      fullWidth
      size="small"
      getOptionLabel={(option) => {
        // (2026-05-14) Solo nombre + bandera IGTF en el dropdown. El codigo
        // de moneda se elimino — el `monto` ya se formatea con el simbolo
        // correcto de la moneda asociada al metodo de pago.
        const igtf = option.aplica_igtf ? ' (IGTF)' : '';
        return `${option.nombre}${igtf}`;
      }}
      // (2026-05-14) renderOption visual: solo badge IGTF cuando aplique.
      renderOption={(props, option) => (
        <li {...props} key={option.codigo}>
          <div className="flex items-center gap-2 w-full">
            <span className="truncate">{option.nombre}</span>
            {option.aplica_igtf && (
              <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
                IGTF
              </span>
            )}
          </div>
        </li>
      )}
      // ← CAMBIO: Buscar por CODIGO (string)
      value={paymentMethods?.find((p) => p.codigo === params.value) || null}
      onChange={(event, newValue) => {
        params.api.setEditCellValue({
          id: params.id,
          field: "metodo_pago_codigo",
          value: newValue ? newValue.codigo : "",
        });
        params.api.stopCellEditMode({ id: params.id, field: "metodo_pago_codigo" });
      }}
      renderInput={(p) => (
        <TextField
          {...p}
          inputRef={inputRef}
          variant="standard"
          placeholder="Seleccione un medio de pago..."
          fullWidth
          InputProps={{
            ...p.InputProps,
            sx: { height: "100%", padding: "0 !important" },
          }}
        />
      )}
      sx={{
        width: "100%",
        height: "100%",
        "& .MuiInputBase-root": {
          height: "100%",
          padding: "0 !important",
          display: "flex",
          alignItems: "center",
        },
      }}
    />
  );
}

function BancoEditCell({ params, bancosVenezuela }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <Autocomplete
      options={bancosVenezuela || []}
      fullWidth
      size="small"
      getOptionLabel={(option) => option.nombre}
      value={bancosVenezuela?.find((b) => b.nombre === params.value) || null}
      onChange={(event, newValue) => {
        params.api.setEditCellValue({
          id: params.id,
          field: "banco",
          value: newValue ? newValue.nombre : "",
        });
      }}
      renderInput={(p) => (
        <TextField
          {...p}
          inputRef={inputRef}
          variant="standard"
          placeholder="Seleccione banco..."
          fullWidth
          InputProps={{
            ...p.InputProps,
            sx: { height: "100%", padding: "0 !important" },
          }}
        />
      )}
      sx={{
        width: "100%",
        height: "100%",
        "& .MuiInputBase-root": {
          height: "100%",
          padding: "0 !important",
          display: "flex",
          alignItems: "center",
        },
      }}
    />
  );
}

function FormProformas() {
  const navigate = useNavigate(); // Hook para redirección
  const [products, setProducts] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);
  // (2026-07-08 D4) Modo global de reporte de formasPago (config `manejo_pagos`,
  // devuelto por /api/config/metodos-pago). Gobierna la columna de conversion
  // de pagos. Default seguro 'siempre_ves' (== default de la BD).
  const [manejoPagos, setManejoPagos] = useState('siempre_ves');
  const [latestExchangeRateHistory, setLatestExchangeRateHistory] = useState(null);
  const [clients, setClients] = useState(null);
  const [endClients, setEndClients] = useState(null);
  const [filterResults, setFilterResults] = useState([]);
  const [filterResultsAdmin, setFilterResultsAdmin] = useState([]);
  const [showResults, setShowResults] = useState(false);
  // (2026-05-13) Req1 P2e: facturacion a terceros desde proforma.
  // - terceros: lista de clientes tercero del emisor seleccionado (padre_id).
  // - clienteEmisorEsEmisor: flag del cliente emisor seleccionado (admin)
  //   o del cliente del usuario logueado (operador). Habilita el toggle doc_tercero.
  const [terceros, setTerceros] = useState([]);
  const [clienteEmisorEsEmisor, setClienteEmisorEsEmisor] = useState(false);
  // (2026-05-14) Multi-moneda en proforma:
  //  - monedas: lista activa de monedas para el selector (catalogo SENIAT).
  //  - monedaExtranjeraCodigo: codigo (USD/EUR) de la moneda_extranjera del
  //    emisor seleccionado / del propio cliente del operador. Es la moneda
  //    en que se almacena el `precio_base` de los productos. Se usa para
  //    convertir el precio a la moneda elegida en la proforma.
  const [monedas, setMonedas] = useState([]);
  const [monedaExtranjeraCodigo, setMonedaExtranjeraCodigo] = useState(null);
  // (2026-07-16 C9) Catálogo 5 (tipo de venta) para el selector. Por defecto la
  // proforma es Interna ('01'); solo cambia si el usuario marca una exportación.
  const [tiposVenta, setTiposVenta] = useState([]);
  // (2026-07-22 Viajes) D1 nivel 1 / D3: `empresas.es_agencia_viajes` del EMISOR.
  // La sección de boletos solo se muestra si el emisor está habilitado como
  // agencia de viajes; así no se agrega ruido a las empresas que no lo son y la
  // UI no puede provocar el 400 del backend (_gate_agencia_viajes).
  //  - operador/visor: se lee de su propia empresa (GET /api/empresas/).
  //  - admin: se lee del emisor que selecciona en el formulario (selectClient).
  // TRI-ESTADO: `null` = AÚN DESCONOCIDO (p. ej. un admin que edita una proforma
  // ya existente y por tanto no pasa por selectClient). Con valor desconocido NO
  // se bloquea el guardado: solo se bloquea cuando consta que la empresa NO está
  // habilitada. Así el gate espeja al backend sin inventar rechazos.
  const [empresaEsAgenciaViajes, setEmpresaEsAgenciaViajes] = useState(null);
  // Sección de boletos colapsable (es alta: 15 campos por boleto).
  const [viajesAbierto, setViajesAbierto] = useState(false);
  // (2026-08-02, ítem 29-ii) Modo de operación del EMISOR del documento
  // ('NumeracionAutomatica' | 'ValidacionDocumento' | null = desconocido).
  //  - operador/visor: de su propia empresa (GET /api/empresas/).
  //  - admin: del emisor que selecciona en el formulario (selectClient).
  //  - fallback: `usuario.cliente.tipo_operacion` del login (auth_routes.py:512).
  // TRI-ESTADO deliberado: con el modo DESCONOCIDO se conserva el comportamiento
  // actual (correlativo visible y obligatorio). Manda SIEMPRE el modo del
  // EMISOR, no el del tercero: es el que usa el backend al emitir
  // (factura_routes.py:1775-1777).
  const [modoOperacionEmisor, setModoOperacionEmisor] = useState(null);
  // (2026-08-03, P4/T3) `empresas.regla_facturacion` del EMISOR
  // ('Separada' | 'Combinada' | null = aún desconocido). Con 'Combinada' y
  // documento a tercero, la comisión del tercero debe venir INCLUIDA en los
  // pagos, así que la capa web añade su línea automáticamente y la mantiene
  // recalculada (decisión del usuario). TRI-ESTADO deliberado: desconocido se
  // trata como 'Separada' (fail-safe: NO se inventan líneas).
  //  - operador/visor: de su propia empresa (GET /api/empresas/).
  //  - admin: del emisor que selecciona en el formulario (selectClient).
  //  - fallback: `usuario.cliente.regla_facturacion` del login.
  const [reglaFacturacionEmisor, setReglaFacturacionEmisor] = useState(null);
  // (2026-08-03, P4/T3) Producto de comisión del EMISOR (`productos.es_tercero`).
  // NO está en `products` cuando doc_tercero está activo: ese catálogo se
  // recarga con los productos del TERCERO (efecto de refresco de catálogos),
  // mientras que el producto de comisión pertenece al EMISOR
  // (factura_routes._obtener_o_crear_producto_tercero). Se resuelve aparte.
  const [productoComisionEmisor, setProductoComisionEmisor] = useState(null);

  // Obtener los query parameters con `useLocation`
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const preInvoiceId = queryParams.get("id"); // Obtener el ID de la URL
  const preInvoiceType = queryParams.get("type");
  const [preInvoice, setPreInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [tab, setTab] = useState("productos"); // Estado para controlar qué DataGrids mostrar
  const authData = localStorage.getItem("authData");
  const rol = authData ? JSON.parse(authData)["rol"] : "";
  var authclientId;
  // (2026-05-13) Req1 P2e: leer es_emisor del cliente vinculado al usuario.
  // El backend lo expone en /api/login bajo usuario.es_emisor (y tambien dentro
  // de usuario.cliente). Solo aplica a operador_admin/operador/visor; para
  // admin se calcula al seleccionar un cliente en el formulario.
  var authClienteEsEmisor = false;
  // (2026-05-13) Req 2: leer moneda_designada del cliente desde el authData
  // (poblado en /api/login). Default 3 (VES) si no esta presente — caso
  // borde donde el cliente no tiene la nueva info (sesion vieja).
  var authMonedaDesignadaId = 3;
  var authMonedaDesignadaObj = null;
  // (2026-05-14) Moneda extranjera del cliente del usuario logueado (operador).
  // Para admin se sobrescribe en selectClient.
  var authMonedaExtranjeraCodigo = null;
  // (2026-08-02, ítem 29-ii) tipo_operacion del cliente del usuario logueado.
  // El backend lo añadió al payload de login (auth_routes.py:504-516).
  var authTipoOperacion = null;
  // (2026-08-03, P4/T3) regla_facturacion del cliente del usuario logueado. El
  // backend la añade al payload de login en este mismo paquete (mismo patrón
  // con el que P2 añadió `tipo_operacion`). Si llegara `undefined` se trata
  // como 'Separada' más abajo (fail-safe).
  var authReglaFacturacion = null;
  if (authData) {
    const parsed = JSON.parse(authData);
    authclientId = parsed['empresa_id'];
    authClienteEsEmisor = !!parsed['es_emisor'];
    // El cliente vinculado (operador) trae moneda_designada/extranjera nested.
    const cli = parsed['cliente'] || {};
    if (cli.moneda_designada_id) authMonedaDesignadaId = cli.moneda_designada_id;
    if (cli.moneda_designada) authMonedaDesignadaObj = cli.moneda_designada;
    if (cli.moneda_extranjera && cli.moneda_extranjera.codigo) {
      authMonedaExtranjeraCodigo = (cli.moneda_extranjera.codigo || '').trim().toUpperCase();
    }
    if (cli.tipo_operacion) authTipoOperacion = cli.tipo_operacion;
    if (cli.regla_facturacion) authReglaFacturacion = cli.regla_facturacion;
  }
  // Modo EFECTIVO del emisor: el resuelto en pantalla (propia empresa / emisor
  // elegido) y, si aún no se resolvió, el del login. Sin hooks: es una derivada
  // pura, así que no altera el orden de los ~30 hooks de este componente.
  const modoOperacionEfectivo = modoOperacionEmisor || authTipoOperacion || null;
  const correlativoAutomatico = esModoNumeracionAutomatica(modoOperacionEfectivo);
  // (2026-08-03, P4/T3) Regla de facturación EFECTIVA del emisor. Misma forma
  // que `modoOperacionEfectivo` (derivada pura, sin hooks). El fallback del
  // login solo aplica a roles NO globales: para admin el `cliente` del authData
  // no es el emisor del documento (lo elige en pantalla). Sin dato =>
  // 'Separada' = NO-OP absoluto: comportamiento idéntico al de hoy.
  const reglaFacturacionEfectiva = reglaFacturacionEmisor
    || (rol !== 'admin' ? authReglaFacturacion : null)
    || 'Separada';
  const type = preInvoiceType != undefined ? decryptText(preInvoiceType) : 'FC';
  //Autofocus
  const apiRef = useGridApiRef();
  const apiRefNd = useGridApiRef();
  const apiRefMp = useGridApiRef();
  const [errors, setErrors] = useState({}); // Estado para errores de validación

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };
  //Campos del DataGrid
  // (2026-08-03, P4/T3) La línea de comisión de tercero (regla COMBINADA) es
  // GENERADA y RECALCULADA por el sistema: no se edita ni se elimina a mano.
  // Se bloquea por FILA con `isCellEditable` (API de MUI DataGrid) — NO tocando
  // el `editable` de la columna, que gobierna la columna entera y sigue valiendo
  // para el resto de las líneas. `processRowUpdate` lleva además la guarda dura.
  const celdaEditableSalvoComision = (params) => !esLineaComisionTercero(params?.row);
  const columns = [
    { field: "id", headerName: "ID", editable: false },
    { field: "nueva_linea", headerName: "Nueva Linea", editable: false },
    //{ field: 'producto_id', headerName: 'Producto', flex: 4, editable: true },
    {
      field: "producto_id",
      headerName: "Producto/Servicio",
      flex: 4,
      editable: true,
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderEditCell: (params) => (
        <ProductoEditCell params={params} products={products} />
      ),
      // esto asegura que en modo "display" se vea el label en vez del id
      // (2026-08-03, P4/T3) La línea de comisión NO está en `products` (ese
      // catálogo es el del TERCERO; el producto de comisión es del EMISOR), así
      // que se pinta con el `nombre` que lleva la propia fila. Firma de MUI X
      // v7: (value, row, column, apiRef) — el primer argumento ES el valor, tal
      // como ya asumía este formatter.
      valueFormatter: (params, row) => {
        if (esLineaComisionTercero(row)) {
          return row.nombre || 'Comision de ventas de tercero';
        }
        const product = products?.find((p) => p.id === params);
        return product ? `${product.sku} - ${product.nombre}` : "";
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      flex: 1,
      type: "number",
      editable: true,
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderCell: (params) => {
        // safe check: params puede ser undefined muy tempranamente, evitamos crash
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    { field: "iva_categoria_id", headerName: "iva_categoria_id", editable: false },
    {
      field: "tasa_porcentaje",
      headerName: "Impuesto (%)",
      flex: 1,
      type: "number",
      editable: false,
      headerAlign: "center",
      renderCell: (params) => {
        // safe check: params puede ser undefined muy tempranamente, evitamos crash
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    {
      field: "precio_unitario",
      // (2026-05-14) Etiqueta dinamica: codigo de moneda de la proforma.
      headerName: `Precio Unitario (${preInvoice?.moneda?.codigo || 'Bs.'})`,
      flex: 1,
      type: "number",
      editable: (type == 'NC' ? false : true),
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderCell: (params) => {
        // safe check: params puede ser undefined muy tempranamente, evitamos crash
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    {
      // (2026-08-02, ítem 30-ii) Tipo de descuento de la LÍNEA. Porcentaje y
      // monto fijo son EXCLUYENTES: el backend da precedencia al porcentaje
      // cuando no es NULL (utils.py:565-575), así que ofrecer los dos a la vez
      // haría desaparecer el monto sin avisar. Al cambiar de tipo,
      // processRowUpdate limpia la columna que deja de aplicar.
      field: "descuento_tipo",
      headerName: "Tipo desc.",
      flex: 1,
      type: "singleSelect",
      valueOptions: [
        { value: 'porcentaje', label: 'Porcentaje (%)' },
        { value: 'monto', label: 'Monto fijo' },
      ],
      editable: (type == 'NC' ? false : true),
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      // El tipo se deriva de la FILA (no solo del valor): las líneas cargadas
      // desde el backend pueden no traer la marca y hay que inferirla del dato.
      valueGetter: (value, row) => tipoDescuentoLinea(row || { descuento_tipo: value }),
    },
    {
      field: "descuento_porcentaje",
      headerName: "Desc (%)",
      flex: 1,
      type: "number",
      editable: true,
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderCell: (params) => {
        // safe check: params puede ser undefined muy tempranamente, evitamos crash
        // (ítem 30-ii) En modo "monto fijo" esta columna NO aplica: se muestra
        // "—" en vez de un 0,00 que parecería un descuento del 0 %.
        if (params?.row && tipoDescuentoLinea(params.row) === 'monto') return '—';
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    {
      // (2026-08-02, ítem 30-ii) Descuento por MONTO FIJO de la línea. El
      // backend lo soporta de punta a punta (modelo, upsert, recálculo,
      // serializador); solo faltaba la UI. Se envía como item.descuento_monto y
      // alimenta descuentoMonto del documento electrónico.
      field: "descuento_monto",
      headerName: `Desc. (${preInvoice?.moneda?.codigo || 'Bs.'})`,
      flex: 1,
      type: "number",
      editable: (type == 'NC' ? false : true),
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderCell: (params) => {
        if (params?.row && tipoDescuentoLinea(params.row) !== 'monto') return '—';
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    {
      // (2026-08-02, ítem 30-ii) Causa del descuento/bonificación de la línea.
      // Es la fuente de `descDescuento` en listaDescBonificacion y de
      // `descripcionBonificacion` del ítem (serializador.py:522-524); el
      // backend ya lo acepta (campos_item_permitidos) y lo arrastra a la
      // factura. Opcional. UpperCase como el resto de los textos del sistema.
      field: "descuento_nombre",
      headerName: "Concepto desc.",
      flex: 1.5,
      editable: (type == 'NC' ? false : true),
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderCell: (params) => formatText(params?.value || '') || '—',
    },
    {
      // (2026-07-20 Recargos) recargo de LÍNEA (MONTO, no %). Se SUMA a la base y
      // genera IVA; se envía como item.recargo_monto (espejo del descuento).
      field: "recargo_monto",
      headerName: `Recargo (${preInvoice?.moneda?.codigo || 'Bs.'})`,
      flex: 1,
      type: "number",
      editable: (type == 'NC' ? false : true),
      isCellEditable: celdaEditableSalvoComision,
      headerAlign: "center",
      renderCell: (params) => {
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    {
      field: "total",
      // (2026-05-14) Etiqueta dinamica.
      headerName: `Total (${preInvoice?.moneda?.codigo || 'Bs.'})`,
      flex: 1,
      sortable: false,
      align: "right",        // alinea el contenido a la derecha
      headerAlign: "center",  // alinea el título de la cabecera a la derecha
      renderCell: (params) => {
        if (!params || !params.row) return "0,00";
        // (2026-08-02, ítem 30-ii) Fórmula ÚNICA (helper de módulo):
        //   cantidad*precio - descuento(% Ó monto fijo) + recargo de línea.
        // Antes ignoraba por completo el descuento por monto.
        return formatDecimal(totalLineaProforma(params.row));
      }
    },
    {
      field: "acciones",
      headerName: "",
      flex: 0.4,
      sortable: false,
      renderCell: (params) => {
        // (2026-08-03, P4/T3) La línea de comisión de tercero NO se elimina a
        // mano: la gobierna `sincronizarLineaComision` (desaparece sola al
        // desactivar doc_tercero, al cambiar a un emisor 'Separada' o al borrar
        // el último producto). Sin papelera no hay forma de dejar el documento
        // descuadrado respecto de los pagos.
        if (esLineaComisionTercero(params?.row)) return null;
        return (
          <Button
            color="bg-slate-800"
            size="small"
            onClick={() => handleDeleteRow(params.row.id)}>
            <i class="fa-solid fa-lg fa-trash me-3"></i>
          </Button>
        );
      },
    },
  ];

  const columnsNd = [
    { field: "id", headerName: "ID", editable: false },
    { field: "nueva_linea", headerName: "Nueva Linea", editable: false },
    { field: "concepto", headerName: "Concepto", editable: true, flex: 4 },
    {
      field: "monto",
      // (2026-05-14) Etiqueta dinamica con codigo de moneda de la proforma.
      headerName: `Monto (${preInvoice?.moneda?.codigo || 'Bs.'})`,
      flex: 1,
      type: "number",
      editable: true,
      headerAlign: "center",
      renderCell: (params) => {
        // safe check: params puede ser undefined muy tempranamente, evitamos crash
        const raw = params?.value ?? 0;
        return formatDecimal(raw);
      },
    },
    {
      field: "acciones",
      headerName: "",
      flex: 0.4,
      sortable: false,
      renderCell: (params) => (
        <Button
          color="bg-slate-800"
          size="small"
          onClick={() => handleDeleteRowNd(params.row.id)}>
          <i class="fa-solid fa-lg fa-trash me-3"></i>
        </Button>
      ),
    },
  ];

   // ← LISTA COMPLETA DE BANCOS VENEZOLANOS (2024)
  const bancosVenezuela = [
    { id: '', nombre: '',},
    { id: '0102', nombre: 'Banco de Venezuela', logo: 'BDV' },
    { id: '0104', nombre: 'Venezolano de Crédito', logo: 'BVC' },
    { id: '0105', nombre: 'Banco Mercantil', logo: 'Mercantil' },
    { id: '0108', nombre: 'BBVA Provincial', logo: 'BBVA' },
    { id: '0114', nombre: 'Bancaribe', logo: 'Bancaribe' },
    { id: '0115', nombre: 'Banco Exterior', logo: 'Exterior' },
    { id: '0128', nombre: 'Banco Caroní', logo: 'Caroni' },
    { id: '0134', nombre: 'Banesco', logo: 'Banesco' },
    { id: '0137', nombre: 'Banco Sofitasa', logo: 'Sofitasa' },
    { id: '0138', nombre: 'Banco Plaza', logo: 'Plaza' },
    { id: '0146', nombre: 'Bangente', logo: 'Bangente' },
    { id: '0151', nombre: 'Banco Fondo Común (BFC)', logo: 'BFC' },
    { id: '0156', nombre: '100% Banco', logo: '100%' },
    { id: '0157', nombre: 'DelSur Banco', logo: 'DelSur' },
    { id: '0163', nombre: 'Banco del Tesoro', logo: 'Tesoro' },
    { id: '0166', nombre: 'Banco Agrícola de Venezuela', logo: 'Agricola' },
    { id: '0168', nombre: 'Bancrecer', logo: 'Bancrecer' },
    { id: '0169', nombre: 'Mi Banco', logo: 'MiBanco' },
    { id: '0171', nombre: 'Banco Activo', logo: 'Activo' },
    { id: '0172', nombre: 'Bancamiga', logo: 'Bancamiga' },
    { id: '0173', nombre: 'Banco Internacional de Desarrollo', logo: 'BID' },
    { id: '0174', nombre: 'Banplus', logo: 'Banplus' },
    { id: '0175', nombre: 'Banco Digital de los Trabajadores', logo: 'BDT' }
  ];

  const columnsMp = [
    { field: "id", headerName: "ID", editable: false },
    { field: "nueva_linea", headerName: "Nueva Linea", editable: false },
    // (2026-05-14) tasa_actual: oculta. Persiste la tasa BCV al momento de
    // registrar el pago para que la validacion de "suma de pagos == total
    // proforma" funcione correctamente cuando los pagos vienen en monedas
    // distintas a la de la proforma. Se setea en processRowUpdateMp.
    { field: "tasa_actual", headerName: "Tasa actual", editable: false },
    {
      field: "metodo_pago_codigo",
      headerName: "Medio de pago",
      flex: 2.5,
      editable: true,
      headerAlign: "center",
      //maxWidth: 150,
      renderEditCell: (params) => (
        <ModoPagoEditCell params={params} paymentMethods={paymentMethods} />
      ),
      valueFormatter: (params) => {
        const codigo = params.value;
        const paymentMethod = paymentMethods?.find((p) => p.codigo === codigo);
        if (!paymentMethod) return codigo || "";
        const mon = paymentMethod.moneda?.codigo ? ` [${paymentMethod.moneda.codigo}]` : '';
        return `${paymentMethod.nombre}${mon} ${paymentMethod.aplica_igtf ? '(IGTF)' : ''}`;
      },
      renderCell: (params) => {
        const codigo = params.value;
        const paymentMethod = paymentMethods?.find((p) => p.codigo === codigo);
        if (!paymentMethod) return codigo || "Sin método";

        return (
          <div className="flex items-center gap-2">
            <span>{paymentMethod.nombre}</span>
            {paymentMethod.moneda?.codigo && (
              <span className="text-xs bg-twilight-indigo-100 text-twilight-indigo-800 px-2 py-1 rounded-full">
                {paymentMethod.moneda.codigo}
              </span>
            )}
            {paymentMethod.aplica_igtf && (
              <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                IGTF
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "aplica_igtf",
      headerName: "IGTF",
      width: 80,
      editable: false, // ← NO editable, se asigna automáticamente
      renderCell: (params) => (
        <div className="flex items-center justify-center">
          {params.value ? (
            <i className="fa-solid fa-check text-green-500 text-sm"></i>
          ) : (
            <i className="fa-solid fa-times text-red-500 text-sm"></i>
          )}
        </div>
      ),
    },
    {
      field: "banco",
      headerName: "Banco",
      flex: 2.5,
      //maxWidth: 200,
      editable: true,
      headerAlign: "center",
      align: "center", // ← IMPORTANTE: Mantiene el alineado de la columna
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        const nombreBanco = params.value || '';
        const metodoPagoCodigo = params.row.metodo_pago_codigo;
        const metodoPago = paymentMethods?.find(p => p.codigo === metodoPagoCodigo);
        const aplicaIgtf = metodoPago?.aplica_igtf || false;

        // ← CASO 1: Sin banco Y sin IGTF → Em dash centrado
        if (!nombreBanco && !aplicaIgtf) {
          return (
            <div className="flex items-center justify-center w-full h-full">
              <span className="text-sm text-gray-500">—</span>
            </div>
          );
        }

        // ← CASO 2: APLICA IGTF → SOLO "N/A" CENTRADO
        if (aplicaIgtf) {
          return (
            <div className="flex items-center justify-center w-full h-full">
              <span className="text-xs bg-red-100 text-red-800 px-3 py-1 rounded-full font-bold whitespace-nowrap">
                N/A
              </span>
            </div>
          );
        }

        // ← CASO 3: Banco seleccionado (NO IGTF) → Nombre del banco
        return (
          <div className="flex items-center justify-center w-full h-full cursor-pointer hover:bg-gray-50 rounded p-1 select-none">
            <span className="truncate text-sm font-medium">
              {nombreBanco}
            </span>
          </div>
        );
      },
      renderEditCell: (params) => {
        const metodoPagoCodigo = params.row.metodo_pago_codigo;
        const metodoPago = paymentMethods?.find(p => p.codigo === metodoPagoCodigo);

        // ← SI APLICA IGTF → MOSTRAR N/A CENTRADO (NO EDITOR)
        if (metodoPago?.aplica_igtf) {
          return (
            <div className="flex items-center justify-center w-full h-full bg-gray-50 rounded p-2">
              <span className="text-xs bg-red-100 text-red-800 px-3 py-1 rounded-full font-bold">
                N/A
              </span>
            </div>
          );
        }

        // ← EDITOR NORMAL si NO aplica IGTF
        return <BancoEditCell params={params} bancosVenezuela={bancosVenezuela} />;
      },
    },
    {
      field: "monto",
      // (2026-05-14) Header simplificado: el monto se formatea por fila
      // usando la moneda asociada al metodo de pago de cada renglon.
      headerName: "Monto",
      flex: 2.5,
      type: "number",
      editable: (type == 'NC' ? false : true),
      headerAlign: "center",
      renderCell: (params) => {
        const raw = params?.value ?? 0;
        // (2026-05-14) Formatear con el simbolo de la moneda del metodo
        // de pago seleccionado en esa fila. Si aun no se eligio metodo,
        // cae a VES por defecto (formatMoney lo maneja).
        const mp = paymentMethods?.find(
          (p) => p.codigo === params.row.metodo_pago_codigo
        );
        const monedaPago = mp?.moneda || null;
        return formatMoney(raw, monedaPago);
      },
    },
    // (2026-07-08 D4) En `siempre_ves`, columna con cada pago convertido a la
    // moneda del documento (VES en el flujo SENIAT) = "el monto aplicado al
    // calculo" (monto x tasa_actual, mismo factor que usa el cuadre en
    // validate()). Solo aporta para medios en moneda != a la del documento;
    // los que ya estan en esa moneda muestran "—".
    ...(manejoPagos === 'siempre_ves' ? [{
      field: "monto_aplicado",
      headerName: `Aplicado (${preInvoice?.moneda?.codigo || 'Bs.'})`,
      flex: 2,
      sortable: false,
      editable: false,
      headerAlign: "center",
      renderCell: (params) => {
        const mp = paymentMethods?.find(
          (p) => p.codigo === params.row.metodo_pago_codigo
        );
        const medioCod = (mp?.moneda?.codigo || '').toUpperCase();
        const docCod = (preInvoice?.moneda?.codigo || 'VES').toUpperCase();
        // Sin conversion si el medio ya esta en la moneda del documento.
        if (!mp || !medioCod || medioCod === docCod) {
          return <span className="text-gray-400">—</span>;
        }
        const monto = Number(params.row.monto) || 0;
        const tasa = Number(params.row.tasa_actual) || 1;
        // Redondeo a 2 decimales inline (self-contained; sin depender de helpers
        // definidos mas abajo en el cuerpo del componente).
        const aplicado = Math.round((monto * tasa) * 100) / 100;
        return <span className="font-medium">{formatMoney(aplicado, preInvoice?.moneda)}</span>;
      },
    }] : []),
    {
      field: "acciones",
      headerName: "",
      flex: 0.4,
      sortable: false,
      //maxWidth: 60,
      renderCell: (params) => (
        <Button
          color="bg-slate-800"
          size="small"
          onClick={() => handleDeleteRowMp(params.row.id)}>
          <i className="fa-solid fa-lg fa-trash me-3"></i>
        </Button>
      ),
    },
  ];
  //Botones para agregar lineas
  const [rows, setRows] = useState([
    //{ id: 1, producto_id: "P001", cantidad: 2, precio_unitario: 1500.0 },
    //{ id: 2, producto_id: "P002", cantidad: 5, precio_unitario: 15.5 },
  ]);

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];
  // Simulando la carga de datos del Proformas por el ID
  useEffect(() => {
    const fetchPreInvoice = async () => {
      try {
        if (rol != 'admin'){
          const datapts = await getProducts();
          setProducts(datapts);
          const datacls = await getEndClients({ page: 1, per_page: 20, request_type: 'export' });
          setEndClients(datacls.data);
        }else{
          setProducts([]);
          setEndClients([]);
        }
        // (2026-05-14) Los metodos de pago activos se cargan para TODOS los
        // roles (admin incluido). El endpoint /api/config/metodos-pago ya
        // filtra por activo=True y ordena por `orden` ascendente.
        try {
          const datamp = await getPaymentMethods();
          setPaymentMethods(datamp);
          // (2026-07-08 D4) El endpoint enriquece cada medio con `manejo_pagos`
          // (mismo valor global en todas las filas). Se lee de la primera fila.
          if (Array.isArray(datamp) && datamp.length > 0 && datamp[0].manejo_pagos) {
            setManejoPagos(datamp[0].manejo_pagos);
          }
        } catch (e) {
          console.error('Error cargando metodos de pago:', e);
          setPaymentMethods([]);
        }
        if (rol == 'admin'){
          // (2026-05-13) En proformas, el "cliente" es el EMISOR principal.
          // Los terceros nunca son emisores; se excluyen del selector.
          const dataclsAdmin = await getClients({ page: 1, per_page: 20, request_type: 'export', es_tercero: false });
          setClients(dataclsAdmin.data);
        }
        // (2026-05-13) Req1 P2e: si el usuario logueado pertenece a un cliente
        // emisor (operador_admin / operador / visor con es_emisor=true), cargar
        // los terceros vinculados a su padre_id para que pueda activar
        // 'doc_tercero' al crear la proforma.
        if (rol != 'admin' && authclientId && authClienteEsEmisor) {
          setClienteEmisorEsEmisor(true);
          // (2026-05-13) Para operador el endpoint /api/empresas/ devuelve un
          // array plano; para admin devuelve { data: [...] }. Usar el
          // normalizador para tolerar ambos.
          const datatcs = await getClients({ es_tercero: true, padre_id: authclientId, activo: true });
          setTerceros(normalizeClientsResponse(datatcs));
        }
        const datalerh = await getLatestExchangeRateHistory();
        setLatestExchangeRateHistory(datalerh);
        // (2026-05-14) Cargar catalogo de monedas activas para el selector.
        try {
          const monedasResp = await getMonedas({ activo: true });
          setMonedas(normalizeMonedasResponse(monedasResp));
        } catch (e) {
          setMonedas([]);
        }
        // (2026-07-16 C9) Catálogo 5 (tipo de venta) para el selector.
        try {
          setTiposVenta(await getTiposVenta());
        } catch (e) {
          setTiposVenta([]);
        }
        // (2026-05-14) Si es operador, su moneda_extranjera viene del authData.
        // Para admin se completara al seleccionar el emisor en el formulario.
        if (rol !== 'admin' && authMonedaExtranjeraCodigo) {
          setMonedaExtranjeraCodigo(authMonedaExtranjeraCodigo);
        }
        // (2026-07-22 Viajes) D1 nivel 1: leer `es_agencia_viajes` del EMISOR.
        // El authData del login NO expone esta marca, por lo que se consulta la
        // empresa propia (GET /api/empresas/ sin filtros devuelve el emisor del
        // operador). Para admin se resuelve en selectClient(). No bloqueante:
        // si falla, la marca queda DESCONOCIDA (null) y decide el backend.
        // Se excluye a los roles GLOBALES (admin/auditor): para ellos getClients
        // pega a /admin/empresas, que devuelve un listado paginado de TODAS las
        // empresas — la primera fila NO es su emisor.
        if (rol !== 'admin' && rol !== 'auditor' && authclientId) {
          try {
            const propia = normalizeClientsResponse(await getClients());
            setEmpresaEsAgenciaViajes(!!(propia[0] && propia[0].es_agencia_viajes));
            // (2026-08-02, ítem 29-ii) Misma llamada, dato adicional: el modo de
            // operación del EMISOR. Se descartaba aquí y era la razón por la que
            // el formulario no sabía si pedir el correlativo interno. Si la
            // respuesta no lo trae, queda el fallback del login (authData).
            if (propia[0] && propia[0].tipo_operacion) {
              setModoOperacionEmisor(propia[0].tipo_operacion);
            }
            // (2026-08-03, P4/T3) Misma llamada, dato adicional: la regla de
            // facturación del EMISOR ('Separada' | 'Combinada'), que decide si
            // la comisión del tercero se agrega como línea de este documento.
            // `EmpresaListSchema` ya la expone (schemas.py:264). Si no viniera,
            // queda el fallback del login y, en último término, 'Separada'.
            if (propia[0] && propia[0].regla_facturacion) {
              setReglaFacturacionEmisor(propia[0].regla_facturacion);
            }
          } catch (e) {
            console.warn('No se pudo leer es_agencia_viajes de la empresa', e);
          }
        }
        var data;
        if (preInvoiceId != null){
          //console.log('type: ', type);
          if (type == 'FC'){
            data = await showPreInvoice(decryptText(preInvoiceId)); // Llamamos a showPreInvoice con el ID
            if (data.igtf_monto > 0){
              data['aplica_igtf'] = true;
              $('#aplica_igtf').prop('checked', true);
              $('.apply_igtf').removeClass('hidden');
            }
            // (2026-05-16 Req#1) Consumo del objeto agrupado cliente:{}.
            // Prefiere el dato VIVO del nested; si el nested es null (cliente
            // ad-hoc sin FK) cae al snapshot plano. Null-safe: ya no revienta.
            {
              const cf = data.cliente || {};
              data.cliente_nombre = cf.nombre ?? data.cliente_nombre;
              data.cliente_rif = cf.rif ?? data.cliente_rif;
              data.cliente_telefono = cf.telefono ?? data.cliente_telefono;
              data.cliente_email = cf.email ?? data.cliente_email;
              data.cliente_direccion = cf.direccion ?? data.cliente_direccion;
            }
            for (var i = 0; i < data.items.length; i++){
              if (data.items[i].iva_categoria_id != undefined && data.items[i].iva_categoria_id != null){
                data.items[i].tasa_porcentaje = data.items[i].iva_categoria.tasa_porcentaje;
              }
            }
            // (2026-08-03, P4/T3) Al REABRIR, la comisión persistida vuelve sin la
            // marca de pantalla, así que quedaba EDITABLE y BORRABLE — contra la
            // decisión del usuario ("sin opción de eliminar ni editar"). Se
            // remarca por el DATO que trae el backend (`producto.es_tercero`,
            // expuesto por PrefacturaItemSchema), NO por la resolución del
            // catálogo del emisor, que puede fallar. Solo MARCA: la
            // sincronización (crear/recalcular/eliminar) sigue restringida a la
            // creación — recalcular aquí volvería a inflar el SAD con la propia
            // comisión.
            marcarLineaComisionPersistida(data.items);
          }else{
            data = await showInvoice(decryptText(preInvoiceId)); // Llamamos a showPreInvoice con el ID
            data['tipo_documento'] = type;
            data['factura_afectada_id'] = data['id'];
            data['id'] = '#';
            data['fecha_factura_old'] = data['fecha_factura'];
            data['fecha_factura'] = formattedDate;
            data['aplica_igtf'] = false;
            data['monto_pagado_divisas'] = 0.0;
            data['igtf_monto'] = 0.0;
            // (2026-05-15) NC/ND heredan SIEMPRE la moneda con que se emitio la
            // factura afectada (no la moneda_designada del cliente). El detalle
            // de la factura ya trae moneda_id/moneda; se conserva explicito y se
            // cae a VES (3) solo si la factura no trajera moneda (legacy).
            data['moneda_id'] = data['moneda_id'] || 3;
            data['moneda'] = data['moneda'] || null;
            // (2026-07-16 C9) NC/ND heredan el tipo de venta de la factura
            // afectada; si la factura legacy no lo trajera, cae a '01' (Interna).
            data['tipo_venta'] = data['tipo_venta'] || '01';
            if (type == 'ND'){
              data['items'] = [];
              data['conceptos_nd'] = [];
              data['pagos'] = [];
            }
          }
          //console.log('data: ', data);
          if (type == 'NC'){
            var itemsNc = [];
            for (var i = 0; i < data.items.length; i++){
              if (data.items[i].cantidad_disponible != 0){
                data.items[i].cantidad = data.items[i].cantidad_disponible;
                // (2026-05-15) La NC se emite en la moneda de la factura
                // afectada: el precio unitario debe tomarse de
                // precio_unitario_aplicada (monto en la moneda emitida),
                // no de precio_unitario (columna legacy VES). Fallback a
                // precio_unitario si _aplicada no esta poblado (NC legacy).
                if (data.items[i].precio_unitario_aplicada != undefined &&
                    data.items[i].precio_unitario_aplicada != null) {
                  data.items[i].precio_unitario = data.items[i].precio_unitario_aplicada;
                }
                if (data.items[i].iva_categoria_id != undefined && data.items[i].iva_categoria_id != null){
                  data.items[i].tasa_porcentaje = data.items[i].iva_categoria.tasa_porcentaje;
                }
                itemsNc.push(data.items[i]);
              }
            }
            data.items = itemsNc;
          }
          // (2026-07-22 Viajes) Normalizar el nodo `/viajes` del documento
          // cargado: el schema lo devuelve como lista anidada (puede faltar en
          // documentos legacy). Se garantizan los tipos que espera el render y
          // el PUT (lista + booleano). En NC/ND se HEREDAN los boletos de la
          // factura afectada, igual que moneda_id / tipo_venta.
          data.viajes = Array.isArray(data.viajes) ? data.viajes : [];
          data.es_boleteria_aerea = !!data.es_boleteria_aerea;
          setPreInvoice(data); // Guardamos los datos del Proformas en el estado
        }else{
          setPreInvoice({
            id: "#",
            // (2026-08-02) Claves DUPLICADAS eliminadas (`empresa_id`,
            // `cliente_nombre` y `cliente_rif` aparecían dos veces en este mismo
            // literal): JavaScript conserva la ÚLTIMA, así que las primeras eran
            // código muerto que el bundler reportaba como warning. Se conservan
            // las que ganaban — el objeto resultante es idéntico.
            cliente_id: "",
            cliente_nombre: "",
            cliente_rif: "",
            cliente_telefono: "",
            cliente_email: "",
            cliente_direccion: "",
            empresa_id: authclientId,
            items: [],
            correlativo_interno: "",
            zona: "",
            aplica_igtf: false,
            monto_pagado_divisas: 0,
            igtf_porcentaje: 3.0,
            igtf_monto: 0,
            tipo_documento: 'FC',
            // (2026-07-16 C9) Tipo de venta (Catálogo 5). Por defecto '01'
            // (Interna); el backend emite este CÓDIGO en tipoDeVenta.
            tipo_venta: '01',
            fecha_factura: formattedDate,
            // (2026-07-08) Fecha de vencimiento OPCIONAL (vacío = contado).
            // Espeja fecha_factura como clave de `preInvoice`; viaja en el
            // payload de crear/actualizar porque se envía el objeto completo.
            fecha_vencimiento: "",
            conceptos_nd: [],
            pagos: [],
            // (2026-07-20 Recargos) recargos GLOBALES {descripcion, monto}. Viajan
            // en el payload (se envía el objeto completo). El backend los prorratea.
            recargos_globales: [],
            // (2026-08-03 P3) descuentos GLOBALES {descripcion, monto}. Espejo
            // INVERSO de los recargos: viajan en el payload (se envía el objeto
            // completo) y el backend los prorratea restando.
            descuentos_globales: [],
            // (2026-05-13) Req 2: moneda por defecto = moneda_designada del cliente
            // del usuario logueado (leida del authData). Cae a VES (3) si no aplica.
            moneda_id: authMonedaDesignadaId,
            moneda: authMonedaDesignadaObj, // info nested para render del simbolo
            // (2026-05-13) Req1 P2e: campos de facturacion a terceros.
            // doc_tercero=true exige tercero_id (cliente con padre_id=empresa_id
            // del emisor). El backend genera dos facturas: principal + comision.
            doc_tercero: false,
            tercero_id: null,
            // (2026-07-22 Viajes) D1 nivel 2: ESTE documento es boleteria aerea.
            // Con la marca activa el backend EXIGE los 15 campos en cada boleto
            // y al menos un boleto (400 propio, no rechazo SENIAT).
            es_boleteria_aerea: false,
            viajes: [],
          })
        }
      } catch (err) {
        //setError('Error al cargar la Proformas');
      } finally {
        setLoading(false); // Indicamos que la carga ha finalizado
      }
    };

    fetchPreInvoice();
  }, [preInvoiceId]); // Recarga si el `preInvoiceId` cambia

  // (2026-05-13) Req1 P2e: cuando doc_tercero esta activo y hay un tercero
  // seleccionado, los productos y clientes finales que se ofrecen en el grid
  // deben corresponder al TERCERO (no al emisor). Al desactivar doc_tercero
  // o cambiar de tercero, refrescamos los catalogos.
  useEffect(() => {
    if (preInvoice?.id !== '#') return; // solo en creacion
    const docTercero = !!preInvoice?.doc_tercero;
    const terceroId = preInvoice?.tercero_id;
    const refetchCatalogos = async () => {
      try {
        if (docTercero && terceroId) {
          const datapts = await getProducts({ client_id: terceroId });
          setProducts(datapts);
          const datacls = await getEndClients({ client_id: terceroId });
          setEndClients(datacls.data || datacls || []);
        } else if (rol !== 'admin') {
          // operador con doc_tercero desactivado: vuelve a sus propios catalogos
          const datapts = await getProducts();
          setProducts(datapts);
          const datacls = await getEndClients({ page: 1, per_page: 20, request_type: 'export' });
          setEndClients(datacls.data || datacls || []);
        }
        // admin con doc_tercero desactivado: ya tiene los productos del emisor
        // seleccionado via selectClient(). No re-fetch aqui.
      } catch (err) {
        console.error('Error refrescando catalogos para tercero:', err);
      }
    };
    refetchCatalogos();
    // Solo dispara cuando cambia el flag o el tercero (intencional).
  }, [preInvoice?.doc_tercero, preInvoice?.tercero_id]);

  // función auxiliar para redondear
  const roundTo = (num, decimals) => {
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
  };

  // (2026-07-20 Recargos) Total de recargos GLOBALES (Σ de la lista) — se prorratea
  // sobre las bases (factor = 1 + R/SAD, SAD = Σ base neta de línea con recargo de
  // línea incluido), ESPEJO del serializador/backend.
  const recargosGlobalTotal = useMemo(() => {
    const lista = preInvoice?.recargos_globales || [];
    return roundTo(lista.reduce((acc, r) => acc + (Number(r?.monto) || 0), 0), 2);
  }, [preInvoice?.recargos_globales]);

  // SAD = Σ (base de línea tras descuento + recargo de línea) sobre los ítems.
  // (2026-08-02, ítem 30-ii) `totalLineaProforma` incluye el descuento por
  // MONTO FIJO; antes esta suma solo restaba el porcentaje.
  const subtotalAntesRecargoGlobal = useMemo(() => {
    if (!preInvoice?.items) return 0;
    return roundTo(preInvoice.items.reduce(
      (acc, item) => acc + totalLineaProforma(item), 0,
    ), 2);
  }, [preInvoice?.items]);

  // (2026-08-03 P3) Total de descuentos GLOBALES (Σ de la lista) — proporción
  // INVERSA del recargo global: se prorratea sobre las MISMAS bases y con el
  // MISMO denominador (SAD), restando en vez de sumar.
  const descuentosGlobalTotal = useMemo(() => {
    const lista = preInvoice?.descuentos_globales || [];
    return roundTo(lista.reduce((acc, dsc) => acc + (Number(dsc?.monto) || 0), 0), 2);
  }, [preInvoice?.descuentos_globales]);

  // factor de prorrateo GLOBAL combinado (descuento y recargo de cabecera).
  // La fórmula vive en el helper de módulo `factorGlobalProrrateo` (probado):
  // aquí solo se cablea. Sin descuento global el valor es idéntico al de antes.
  const factorRecargoGlobal = useMemo(() => factorGlobalProrrateo(
    subtotalAntesRecargoGlobal, descuentosGlobalTotal, recargosGlobalTotal,
  ), [subtotalAntesRecargoGlobal, descuentosGlobalTotal, recargosGlobalTotal]);

  // ── (2026-08-03, P4/T3) COMISIÓN DE TERCERO EN REGLA «COMBINADA» ───────────
  // Decisión del usuario: con `empresas.regla_facturacion == 'Combinada'` y
  // documento a tercero, el monto de la comisión debe venir INCLUIDO en los
  // pagos. Por eso la capa web añade la línea AUTOMÁTICAMENTE (ni editable ni
  // eliminable) al agregar el primer producto y la RECALCULA en cada cambio,
  // de modo que los totales y el cuadre de pagos del formulario la contengan y
  // el saldo pagado no presente inconsistencias.
  // Con 'Separada' (o documento no-tercero) esto es NO-OP absoluto.

  // Porcentaje de comisión del tercero seleccionado (`comision_servicio`, ya
  // expuesto por EmpresaListSchema, schemas.py:260). Sin tercero o sin
  // porcentaje NO hay línea.
  const comisionPctTercero = useMemo(() => {
    if (!preInvoice?.doc_tercero || !preInvoice?.tercero_id) return 0;
    const t = (terceros || []).find((x) => x && x.id === preInvoice.tercero_id);
    return Number(t?.comision_servicio) || 0;
  }, [terceros, preInvoice?.doc_tercero, preInvoice?.tercero_id]);

  // Condición de ACTIVACIÓN. Solo FC: en NC/ND el backend no abre la rama
  // Combinada (factura_routes.py:2683-2684 exige tipo_doc == 'FC').
  //
  // SOLO EN CREACIÓN (`id == '#'`), y no por comodidad: al REABRIR una proforma
  // ya guardada sus ítems vuelven del backend SIN la marca de pantalla
  // `_es_comision`, de modo que la comisión persistida se leería como una línea
  // propia más — la sincronización añadiría una SEGUNDA comisión y además
  // inflaría el SAD con la primera. Es el mismo criterio que ya usa el efecto de
  // refresco de catálogos de tercero (`preInvoice?.id !== '#'` -> return) y que
  // el propio bloque de UI «Documento a Tercero», que solo se pinta al crear.
  const aplicaComisionCombinada = (
    preInvoice?.id === '#'
    && !!preInvoice?.doc_tercero
    && !!preInvoice?.tercero_id
    && reglaFacturacionEfectiva === 'Combinada'
    && type === 'FC'
    && comisionPctTercero > 0
  );

  // Resolución del PRODUCTO de comisión del emisor (`es_tercero=true`). Se
  // busca primero en el catálogo en memoria y, si no está (caso normal: con
  // doc_tercero activo `products` son los productos del TERCERO), se pide el
  // catálogo del EMISOR. No bloqueante: si no se encuentra, la línea viaja sin
  // producto y el backend lo resuelve o lo crea
  // (factura_routes._obtener_o_crear_producto_tercero).
  useEffect(() => {
    if (!aplicaComisionCombinada) return undefined;
    if (productoComisionEmisor) return undefined;
    let cancelado = false;
    const resolver = async () => {
      try {
        const enMemoria = (products || []).find((p) => p && p.es_tercero === true);
        if (enMemoria) {
          if (!cancelado) setProductoComisionEmisor(enMemoria);
          return;
        }
        const idEmisor = rol === 'admin' ? preInvoice?.empresa_id : authclientId;
        if (!idEmisor || idEmisor === '#') return;
        const lista = await getProducts({ client_id: idEmisor });
        const hallado = (Array.isArray(lista) ? lista : [])
          .find((p) => p && p.es_tercero === true) || null;
        if (!cancelado && hallado) setProductoComisionEmisor(hallado);
      } catch (e) {
        console.warn('No se pudo resolver el producto de comision del emisor', e);
      }
    };
    resolver();
    return () => { cancelado = true; };
    // (deps omitidas a propósito; NO usar eslint-disable de esa regla: no está registrada en la config del proyecto y ROMPE el build de CRA)
  }, [aplicaComisionCombinada, products, rol, preInvoice?.empresa_id]);

  // SINCRONIZACIÓN de la línea: crear / recalcular / eliminar. Único punto de
  // escritura de la fila `_es_comision` DURANTE LA EDICIÓN en pantalla (al
  // reabrir la marca la pone `marcarLineaComisionPersistida`, que no calcula).
  //
  // GUARDA CONTRA BUCLE: el efecto escribe en `preInvoice.items`, que es su
  // propia dependencia. Por eso SIEMPRE compara antes de escribir y devuelve la
  // MISMA referencia (`prev`) cuando no hay nada que cambiar — React descarta
  // el re-render y el ciclo converge en una pasada.
  const sincronizarLineaComision = () => {
    setPreInvoice((prev) => {
      if (!prev || !Array.isArray(prev.items)) return prev;
      // GUARDA DE REAPERTURA — NO es redundante con la condición de activación.
      // `aplicaComisionCombinada` ya exige `id === '#'`, pero la rama de
      // ELIMINACIÓN de más abajo se dispara precisamente cuando esa condición
      // es FALSA: sin este corte, abrir una proforma guardada (cuya línea de
      // comisión SÍ viene marcada por `marcarLineaComisionPersistida`) la
      // borraría de la pantalla y el PUT la enviaría sin comisión. Al reabrir,
      // el importe ya lo validó y persistió el servidor: aquí no se crea, no se
      // recalcula y no se elimina NADA.
      if (prev.id !== '#') return prev;
      const items = prev.items;
      const idx = items.findIndex(esLineaComisionTercero);
      const monto = aplicaComisionCombinada
        ? comisionTerceroCombinada(
            items, comisionPctTercero, descuentosGlobalTotal, recargosGlobalTotal,
          )
        : 0;
      // Sin condición, sin líneas propias o sin monto: NO debe existir la fila.
      // Se elimina para que al desactivar doc_tercero, cambiar a un emisor
      // 'Separada' o borrar el último producto no quede basura.
      if (!aplicaComisionCombinada || monto <= 0) {
        if (idx < 0) return prev; // NO-OP absoluto (caso 'Separada').
        return { ...prev, items: items.filter((it) => !esLineaComisionTercero(it)) };
      }
      // Datos que aporta el producto de comisión del emisor (si ya se resolvió).
      // `nombre` es un campo ACEPTADO por el backend en la creación
      // (factura_routes.py:2095) y en el upsert (campos_item_permitidos).
      // 'Comision de ventas de tercero' es literalmente
      // PRODUCTO_TERCERO_DEFAULT_NOMBRE (factura_routes.py:119).
      const prod = productoComisionEmisor;
      const datosProducto = {
        producto_id: prod ? prod.id : null,
        nombre: (prod && prod.nombre) || 'Comision de ventas de tercero',
        aplica_iva: prod ? !!prod.aplica_iva : true,
        iva_categoria_id: prod ? (prod.iva_categoria_id || prod.iva_categoria?.id || null) : null,
        tasa_porcentaje: prod ? (Number(prod.iva_categoria?.tasa_porcentaje) || 0) : 0,
      };
      if (idx >= 0) {
        // Ya existe: solo se toca si el monto cambió (guarda de igualdad
        // estricta sobre el número YA redondeado) o si el producto de comisión
        // se resolvió DESPUÉS de crear la fila (llega por red).
        const actual = items[idx];
        const completarProducto = !!prod && !actual.producto_id;
        if (Number(actual.precio_unitario) === monto && !completarProducto) return prev;
        const nuevos = items.slice();
        nuevos[idx] = {
          ...actual,
          ...(completarProducto ? datosProducto : {}),
          cantidad: 1,
          precio_unitario: monto,
        };
        return { ...prev, items: nuevos };
      }
      // No existe: se crea. `id` con la misma regla que handleAddRow.
      const nuevoId = items.length > 0
        ? Math.max(...items.map((r) => Number(r.id) || 0)) + 1
        : 1;
      const fila = {
        id: nuevoId,
        nueva_linea: true,
        _es_comision: true,
        ...datosProducto,
        cantidad: 1,
        precio_unitario: monto,
        // La comisión no admite descuento ni recargo propios (el backend la
        // emite como cantidad 1 × monto).
        descuento_tipo: 'porcentaje',
        descuento_porcentaje: 0,
        descuento_monto: 0,
        descuento_nombre: "",
        recargo_monto: 0,
      };
      return { ...prev, items: [...items, fila] };
    });
  };

  useEffect(() => {
    sincronizarLineaComision();
    // Dependencias: las LÍNEAS propias (cantidades, precios, descuentos y
    // recargos de línea viven dentro de `items`), los descuentos/recargos
    // GLOBALES, y las tres piezas de la condición (doc_tercero + tercero_id
    // resumidos en el porcentaje, y la regla del emisor).
    // (deps omitidas a propósito; NO usar eslint-disable de esa regla: no está registrada en la config del proyecto y ROMPE el build de CRA)
  }, [
    preInvoice?.items, aplicaComisionCombinada, comisionPctTercero,
    descuentosGlobalTotal, recargosGlobalTotal, productoComisionEmisor,
  ]);

  //Calcular base imponible de la Proformas
  const taxBase = useMemo(() => {
    if (!preInvoice?.items && !preInvoice?.conceptos_nd) return 0;

    const baseTotal = preInvoice.items.reduce((acc, item) => {
      // (2026-08-02, ítem 30-ii) Base de la línea con descuento por % Ó por
      // MONTO FIJO (helper de módulo, espejo de utils.py:561-590) + recargo.
      return acc + totalLineaProforma(item);
    }, 0);

    const baseTotalNd = (preInvoice.conceptos_nd ? (preInvoice.conceptos_nd.reduce((acc, item) => {
      const monto = Number(item.monto) || 0;

      // redondear a 4 decimales por línea
      return acc + roundTo(monto, 2);
    }, 0)) : 0.0);

    // (2026-07-20 Recargos) subtotal con recargo global prorrateado (= SAD + R).
    return roundTo(baseTotal * factorRecargoGlobal + baseTotalNd, 2);
  }, [preInvoice?.items, preInvoice?.conceptos_nd, factorRecargoGlobal]);

  //Calcular iva de la Proformas
  const taxApplied = useMemo(() => {
    if (!preInvoice?.items) return 0;

    const taxTotal = preInvoice.items.reduce((acc, item) => {
      const tasa_porcentaje = Number(item.tasa_porcentaje) || 0;
      // (2026-08-02, ítem 30-ii) La base gravable de la línea sale del helper
      // (incluye descuento por % o por monto fijo, y el recargo de línea).
      const taxLine = totalLineaProforma(item) * (tasa_porcentaje / 100);

      // redondear a 4 decimales por línea
      return acc + roundTo(taxLine, 2);
    }, 0);

    const taxNd = (preInvoice.conceptos_nd ? (preInvoice.conceptos_nd.reduce((acc, item) => {
      const monto = Number(item.monto) || 0;
      const tasa_porcentaje = Number(item.tasa_porcentaje) || 0;
      // redondear a 4 decimales por línea
      return acc + roundTo((monto * (tasa_porcentaje / 100)), 2);
    }, 0)) : 0.0);

    // (2026-07-20 Recargos) IVA con el recargo global prorrateado (× factor).
    return roundTo(taxTotal * factorRecargoGlobal + taxNd, 2);
  }, [preInvoice?.items, preInvoice?.conceptos_nd, factorRecargoGlobal]);

  //Calcular total de la Proformas
  const totalAmount = useMemo(() => {
    if (!preInvoice?.items && !preInvoice?.conceptos_nd) return 0;

    const total = preInvoice.items.reduce((acc, item) => {
      const tasa_porcentaje = Number(item.tasa_porcentaje) || 0;
      // (2026-08-02, ítem 30-ii) Base de línea (con descuento % o monto fijo y
      // recargo) × (1 + IVA).
      const totalLine = totalLineaProforma(item) * (1 + (tasa_porcentaje / 100));

      // redondear a 4 decimales por línea
      return acc + roundTo(totalLine, 2);
    }, 0);

    const totalNd = (preInvoice.conceptos_nd ? (preInvoice.conceptos_nd.reduce((acc, item) => {
      const monto = Number(item.monto) || 0;
      const tasa_porcentaje = Number(item.tasa_porcentaje) || 0;
      // redondear a 4 decimales por línea
      return acc + roundTo((monto * (1 + (tasa_porcentaje / 100))), 2);
    }, 0)) : 0.0);

    // (2026-07-20 Recargos) total con el recargo global prorrateado (× factor).
    return roundTo(total * factorRecargoGlobal + totalNd, 2);
  }, [preInvoice?.items, preInvoice?.conceptos_nd, factorRecargoGlobal]);

  // (2026-07-20 Recargos) Handlers de la lista de recargos GLOBALES {descripcion, monto}.
  const addRecargoGlobal = () => {
    setPreInvoice((prev) => ({
      ...prev,
      recargos_globales: [...(prev?.recargos_globales || []), { descripcion: "", monto: 0 }],
    }));
  };
  const updateRecargoGlobal = (idx, field, value) => {
    setPreInvoice((prev) => {
      const lista = [...(prev?.recargos_globales || [])];
      // Convención UpperCase en textos (memoria feedback_uppercase_inputs).
      const val = field === 'descripcion' ? String(value).toUpperCase() : value;
      lista[idx] = { ...lista[idx], [field]: val };
      return { ...prev, recargos_globales: lista };
    });
  };
  const removeRecargoGlobal = (idx) => {
    setPreInvoice((prev) => ({
      ...prev,
      recargos_globales: (prev?.recargos_globales || []).filter((_, i) => i !== idx),
    }));
  };

  // (2026-08-03 P3) Handlers de la lista de descuentos GLOBALES {descripcion,
  // monto}. ESPEJO EXACTO de los tres de arriba (misma forma de fila, misma
  // convención UpperCase en la descripción); lo único inverso es su efecto en el
  // factor, que decide `factorGlobalProrrateo`.
  const addDescuentoGlobal = () => {
    setPreInvoice((prev) => ({
      ...prev,
      descuentos_globales: [...(prev?.descuentos_globales || []), { descripcion: "", monto: 0 }],
    }));
  };
  const updateDescuentoGlobal = (idx, field, value) => {
    setPreInvoice((prev) => {
      const lista = [...(prev?.descuentos_globales || [])];
      // Convención UpperCase en textos (memoria feedback_uppercase_inputs).
      const val = field === 'descripcion' ? String(value).toUpperCase() : value;
      lista[idx] = { ...lista[idx], [field]: val };
      return { ...prev, descuentos_globales: lista };
    });
  };
  const removeDescuentoGlobal = (idx) => {
    setPreInvoice((prev) => ({
      ...prev,
      descuentos_globales: (prev?.descuentos_globales || []).filter((_, i) => i !== idx),
    }));
  };

  // (2026-07-22 Viajes) Handlers de la lista repetible de boletos (nodo /viajes).
  // Mismo patrón que los recargos globales: agregar / actualizar / quitar sobre
  // una lista dentro de `preInvoice`. Un documento puede cubrir N boletos (D2).
  const addViaje = () => {
    setViajesAbierto(true);
    setPreInvoice((prev) => ({
      ...prev,
      viajes: [...(prev?.viajes || []), nuevoViajeVacio()],
    }));
  };
  const updateViaje = (idx, field, value) => {
    setPreInvoice((prev) => {
      const lista = [...(prev?.viajes || [])];
      // Convención UpperCase en los inputs de texto del proyecto.
      //
      // EXCEPCIÓN (decisión del cliente 2026-07-22): los dos campos de HORA
      // quedan EXENTOS. Motivo de coherencia interna del documento fiscal: el
      // sistema genera las horas en minúscula (`utils.hora12()` termina en
      // `.lower()`), de modo que `horaEmision` sale '08:30:00 am'. Si aquí se
      // forzara la mayúscula, el MISMO documento llevaría dos formatos de hora
      // distintos ('08:30:00 am' en el encabezado y '08:30:00 AM' en los
      // viajes). El ejemplo de la norma también está en minúscula.
      const _EXENTOS_UPPER = ['hora_salida', 'hora_llegada'];
      const _val = _EXENTOS_UPPER.includes(field) ? value : String(value).toUpperCase();
      lista[idx] = { ...lista[idx], [field]: _val };
      return { ...prev, viajes: lista };
    });
  };
  const removeViaje = (idx) => {
    setPreInvoice((prev) => ({
      ...prev,
      viajes: (prev?.viajes || []).filter((_, i) => i !== idx),
    }));
  };

  // (2026-07-22 Viajes) D3: la sección solo existe si el EMISOR es agencia de
  // viajes. Se añade una salvaguarda para no ocultar datos ya persistidos: si el
  // documento cargado YA trae boletos o la marca de boletería, la sección se
  // muestra aunque la marca de la empresa se haya desactivado después.
  const mostrarSeccionViajes =
    empresaEsAgenciaViajes === true ||
    !!preInvoice?.es_boleteria_aerea ||
    (preInvoice?.viajes || []).length > 0;

  //Calcular monto del igtf en la Proformas
  const igtfAmount = useMemo(() => {
    if (!preInvoice?.pagos) return 0;

    // Calcular monto_pagado_divisas sumando SOLO los montos de pagos que
    // aplican IGTF, CONVERTIDOS a la moneda de la proforma.
    // (2026-05-18) BUG corregido: antes se sumaba el `monto` crudo del pago
    // (p. ej. 200 USD se trataba como 200 Bs si la proforma era VES), por lo
    // que el IGTF quedaba mal calculado. `tasa_actual` es el factor que
    // convierte 1 unidad de la moneda del metodo de pago a la moneda de la
    // proforma (espejo del backend convertir_monto_pago_a_moneda_documento):
    //   monto_en_proforma = monto * tasa_actual
    let montoPagadoDivisas = 0;
    for (let i = 0; i < preInvoice.pagos.length; i++) {
      if (preInvoice.pagos[i].aplica_igtf === true) {
        const _m = Number(preInvoice.pagos[i].monto) || 0;
        const _t = Number(preInvoice.pagos[i].tasa_actual) || 1;
        montoPagadoDivisas += _m * _t;
      }
    }
    montoPagadoDivisas = roundTo(montoPagadoDivisas, 2);
    if (montoPagadoDivisas > totalAmount){
      montoPagadoDivisas = totalAmount;
    }
    // Actualizar el estado con el monto calculado (opcional, para mostrarlo)
    setPreInvoice(prev => ({
      ...prev,
      monto_pagado_divisas: montoPagadoDivisas
    }));
    if (montoPagadoDivisas > 0){
      $('.apply_igtf').removeClass('hidden');
    }else{
      $('.apply_igtf').addClass('hidden');
    }
    const igtfAmount = montoPagadoDivisas * ((preInvoice.igtf_porcentaje || 3.0) / 100);

    return roundTo(igtfAmount, 2);
  }, [preInvoice?.pagos, preInvoice?.igtf_porcentaje]); // Dependencias correctas

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  const validate = () => {
    console.log('validate-preInvoice: ', preInvoice);
    const newErrors = {};
    var errorToast = [];
    // (2026-05-13) Req1 P2e: si el emisor permite doc_tercero y el usuario lo
    // activo, debe seleccionar un tercero (cliente con padre_id=empresa_id).
    if (preInvoice.doc_tercero) {
      if (!clienteEmisorEsEmisor) {
        newErrors.doc_tercero = "El emisor seleccionado no es es_emisor=true; no puede emitir documentos a terceros.";
        errorToast.push("- El emisor seleccionado no permite documentos a terceros.");
      }
      if (!preInvoice.tercero_id) {
        newErrors.tercero_id = "Debe seleccionar un cliente tercero cuando 'Documento a tercero' está activo.";
        errorToast.push("- Debe seleccionar un cliente tercero.");
      }
    }
    if (!preInvoice.fecha_factura) {
      newErrors.fecha_factura = "Fecha es obligatorio";
      errorToast.push("- Debe indicar la fecha del documento.");
      //toast.error("Debe indicar la fecha del documento.");
      setButtonDisabled(false);
      //return;
    }
    // (2026-05-14) Cliente final: dos modos validos
    //   a) Cliente existente: cliente_id es un id numerico > 0.
    //   b) Cliente nuevo: el backend (POST /api/pre-invoices/) auto-registra
    //      al cliente cuando recibe RIF + nombre + telefono + email +
    //      direccion, sin importar si el frontend marco cliente_id='#'
    //      o lo dejo vacio. Por eso aqui NO bloqueamos por ausencia de id —
    //      basta con tener los datos completos para el registro automatico.
    // Caso (a): si hay id numerico, asumimos que el cliente existe en BD y
    //           los campos fueron pre-cargados al seleccionarlo; solo
    //           validamos el formato de RIF/email/telefono mas abajo.
    // Caso (b): si no hay id, exigimos los campos para que el backend pueda
    //           crear el cliente al vuelo.
    const isClienteExistente = !!(
      preInvoice.cliente_id &&
      preInvoice.cliente_id !== '#' &&
      Number(preInvoice.cliente_id) > 0
    );
    if (!isClienteExistente && !preInvoice.cliente_rif) {
      newErrors.cliente_rif = "R.I.F. del cliente es obligatorio";
      errorToast.push("- Debe indicar el R.I.F. del cliente.");
      setButtonDisabled(false);
    }
    if (preInvoice.cliente_rif){
      if (!validateFormatRif(preInvoice.cliente_rif)){
        newErrors.cliente_rif = "R.I.F. del cliente no presenta un formato válido";
        errorToast.push("- R.I.F. del cliente no presenta un formato válido");
      }
    }
    if (!isClienteExistente && !preInvoice.cliente_nombre) {
      newErrors.cliente_nombre = "Nombre del cliente es obligatorio";
      errorToast.push("- Debe indicar el nombre cliente.");
      setButtonDisabled(false);
    }
    if (!preInvoice.cliente_telefono) {
      newErrors.cliente_telefono = "Teléfono del cliente es obligatorio";
      errorToast.push("- Debe indicar el teléfono del cliente.");
      //toast.error("Debe indicar el teléfono del cliente.");
      setButtonDisabled(false);
      //return;
    }
    if (preInvoice.cliente_telefono){
      if (!validateFormatPhone(preInvoice.cliente_telefono)){
        newErrors.cliente_telefono = "Teléfono del cliente no presenta un formato válido";
        errorToast.push("- Teléfono del cliente no presenta un formato válido");
      }
    }
    if (!preInvoice.cliente_email) {
      newErrors.cliente_email = "Correo electrónico del cliente es obligatorio";
      errorToast.push("- Debe indicar el correo electrónico del cliente.");
      //toast.error("Debe indicar el correo electrónico del cliente.");
      setButtonDisabled(false);
      //return;
    }
    if (preInvoice.cliente_email){
      if (!validateFormatEmail(preInvoice.cliente_email)){
        newErrors.cliente_email = "Correo electrónico no presenta un formato válido";
        errorToast.push("- Correo electrónico no presenta un formato válido");
        setButtonDisabled(false);
      }
    }
    if (!preInvoice.cliente_direccion) {
      newErrors.cliente_direccion = "Dirección del cliente es obligatoria";
      errorToast.push("- Debe indicar la dirección de cliente.");
      //toast.error("Debe indicar la dirección de cliente.");
      setButtonDisabled(false);
      //return;
    }
    // (2026-08-02, ítem 29-ii) El correlativo interno SOLO es obligatorio en
    // ValidacionDocumento (o con el modo desconocido). En NumeracionAutomatica
    // el sistema asigna el consecutivo y el backend NO lo exige
    // (factura_routes.py:827-835): el formulario imponía un requisito que la API
    // no tiene, e impedía crear proformas a esas empresas.
    if (!correlativoAutomatico && !preInvoice.correlativo_interno) {
      newErrors.correlativo_interno = "Correlativo interno es obligatorio";
      errorToast.push("- Debe indicar el correlativo interno del documento.");
      //toast.error("Debe indicar el correlativo interno del documento.");
      setButtonDisabled(false);
      //return;
    }
    // (2026-08-02, ítem 34) Coherencia de la Fecha de Vencimiento (opcional:
    // vacío = contado). Si viene informada debe ser válida y >= fecha del
    // documento. NO se le pone default ni se vuelve obligatoria.
    {
      const _errVenc = validarFechaVencimiento(
        preInvoice.fecha_factura, preInvoice.fecha_vencimiento,
      );
      if (_errVenc) {
        newErrors.fecha_vencimiento = _errVenc;
        errorToast.push("- " + _errVenc);
        setButtonDisabled(false);
      }
    }
    if (!preInvoice.zona) {
      newErrors.zona = "Zona es obligatoria";
      errorToast.push("- Debe indicar la zona del documento.");
      //toast.error("Debe indicar la zona del documento.");
      setButtonDisabled(false);
      //return;
    }
    if (preInvoice.tipo_documento != 'ND' && preInvoice.items.length == 0) {
      if (newErrors.items == undefined){
        newErrors.items = [];
      }
      newErrors.items.push("Lineas son obligatorias");
      errorToast.push("- Debe ingresar las lineas del documento.");
      //toast.error("Debe ingresar las lineas del documento.");
      setButtonDisabled(false);
      //return;
    }
    for (var i = 0; i < preInvoice.items.length; i++){
      // (2026-08-03, P4/T3) La línea de comisión de tercero (regla COMBINADA) la
      // GENERA el sistema y su producto pertenece al EMISOR, no al catálogo del
      // TERCERO que alimenta el grid. Cuando no se pudo resolver en pantalla,
      // quien lo resuelve —o lo crea— es el backend
      // (factura_routes._obtener_o_crear_producto_tercero): exigir aquí el
      // producto y su categoría de IVA bloquearía el guardado de un documento
      // correcto. Las demás reglas (cantidad > 0, precio > 0, descuentos) SÍ se
      // le aplican igual que a cualquier otra línea.
      const _esComisionItem = esLineaComisionTercero(preInvoice.items[i]);
      if (!preInvoice.items[i].producto_id && !_esComisionItem) {
        if (newErrors.items == undefined){
          newErrors.items = [];
        }
        newErrors.items.push("No se pueden procesar las lineas sin producto/servicio especificado.");
        errorToast.push("- No se pueden procesar las lineas sin producto/servicio especificado.");
        //toast.error("No se pueden procesar las lineas sin producto especificado.");
        setButtonDisabled(false);
        //return;
      }
      if (preInvoice.items[i].cantidad <= 0) {
        if (newErrors.items == undefined){
          newErrors.items = [];
        }
        newErrors.items.push("No se pueden procesar las lineas con cantidades menor o igual que 0.");
        errorToast.push("- No se pueden procesar las lineas con cantidades menor o igual que 0.");
        //toast.error("No se pueden procesar las lineas con cantidades menor o igual que 0.");
        setButtonDisabled(false);
        //return;
      }
      if (preInvoice.tipo_documento == 'NC'){
        if (preInvoice.items[i].cantidad > preInvoice.items[i].cantidad_disponible) {
          if (newErrors.items == undefined){
            newErrors.items = [];
          }
          newErrors.items.push(`No se puede procesar la linea del producto/servicio (${preInvoice.items[i].producto.nombre}) debido a que la cantidad asignada supera la cantidad disponible (${preInvoice.items[i].cantidad_disponible}).`);
          errorToast.push(`- No se puede procesar la linea del producto/servicio (${preInvoice.items[i].producto.nombre}) debido a que la cantidad asignada supera la cantidad disponible (${preInvoice.items[i].cantidad_disponible}).`);
          //toast.error("No se pueden procesar las lineas con cantidades menor o igual que 0.");
          setButtonDisabled(false);
          //return;
        }
      }
      if (!preInvoice.items[i].iva_categoria_id && !_esComisionItem) {
        if (newErrors.items == undefined){
          newErrors.items = [];
        }
        newErrors.items.push("No se pueden procesar las lineas sin impuesto especificado.");
        errorToast.push("- No se pueden procesar las lineas sin impuesto especificado.");
        //toast.error("No se pueden procesar las lineas sin impuesto especificado.");
        setButtonDisabled(false);
        //return;
      }
      if (preInvoice.items[i].precio_unitario <= 0) {
        if (newErrors.items == undefined){
          newErrors.items = [];
        }
        newErrors.items.push("No se pueden procesar las lineas con precio unitario menor o igual que 0.");
        errorToast.push("- No se pueden procesar las lineas con precio unitario menor o igual que 0.");
        //toast.error("No se pueden procesar las lineas con precio unitario menor o igual que 0.");
        setButtonDisabled(false);
        //return;
      }
      // (2026-08-02, remediación H14) Las reglas del PORCENTAJE solo aplican en
      // modo porcentaje. En modo monto fijo el % es un campo muerto (viaja NULL)
      // y estas comprobaciones podían rechazar una línea perfectamente válida
      // que arrastrase un % viejo de una edición anterior.
      if (tipoDescuentoLinea(preInvoice.items[i]) !== 'monto') {
        if (preInvoice.items[i].descuento_porcentaje < 0) {
          if (newErrors.items == undefined){
            newErrors.items = [];
          }
          newErrors.items.push("No se pueden procesar las lineas con descuentos menor que 0.");
          errorToast.push("- No se pueden procesar las lineas con descuentos menor que 0.");
          //toast.error("No se pueden procesar las lineas con descuentos menor que 0.");
          setButtonDisabled(false);
          //return;
        }
        if (preInvoice.items[i].descuento_porcentaje >= 100) {
          if (newErrors.items == undefined){
            newErrors.items = [];
          }
          newErrors.items.push("No se pueden procesar las lineas con descuentos mayores o iguales al 100%.");
          errorToast.push("- No se pueden procesar las lineas con descuentos mayores o iguales al 100%.");
          //toast.error("No se pueden procesar las lineas con descuentos mayores o iguales al 100%.");
          setButtonDisabled(false);
          //return;
        }
      }
      // (2026-08-02, ítem 30-ii) Descuento por MONTO FIJO — ESPEJO EXACTO de
      // utils.py:569-575: no negativo y NO mayor que el subtotal de la línea
      // (a diferencia del recargo, que sí puede superar la base). La regla vive
      // en `validarDescuentoMontoLinea` (helper de módulo, probado aparte).
      const _errDm = validarDescuentoMontoLinea(preInvoice.items[i]);
      if (_errDm) {
        if (newErrors.items == undefined){ newErrors.items = []; }
        newErrors.items.push(_errDm);
        errorToast.push("- " + _errDm);
        setButtonDisabled(false);
      }
      // (2026-07-20 Recargos) recargo de línea NO negativo (espejo del backend).
      if (Number(preInvoice.items[i].recargo_monto) < 0) {
        if (newErrors.items == undefined){
          newErrors.items = [];
        }
        newErrors.items.push("No se pueden procesar las lineas con recargos menores que 0.");
        errorToast.push("- No se pueden procesar las lineas con recargos menores que 0.");
        setButtonDisabled(false);
      }
    }
    // (2026-07-20 Recargos) recargos GLOBALES: monto NO negativo (espejo backend).
    for (let r = 0; r < (preInvoice.recargos_globales || []).length; r++) {
      if (Number(preInvoice.recargos_globales[r].monto) < 0) {
        if (newErrors.items == undefined){ newErrors.items = []; }
        newErrors.items.push("Los recargos globales no pueden tener monto negativo.");
        errorToast.push("- Los recargos globales no pueden tener monto negativo.");
        setButtonDisabled(false);
      }
    }
    // (2026-08-03 P3) descuentos GLOBALES — ESPEJO de las DOS reglas del backend:
    // (a) monto no negativo por fila, (b) cota dura Σ D <= SAD (si no, el
    // documento tendría bases imponibles negativas). Ambas viven en el helper
    // `validarDescuentoGlobal`, que es lo que prueba la suite.
    {
      const _sumaDescGlob = (preInvoice.descuentos_globales || []).reduce(
        (acc, dsc) => acc + (Number(dsc?.monto) || 0), 0,
      );
      const _sadValidate = (preInvoice.items || []).reduce(
        (acc, it) => acc + totalLineaProforma(it), 0,
      );
      const _errDescGlob = validarDescuentoGlobal(_sumaDescGlob, _sadValidate);
      if (_errDescGlob) {
        if (newErrors.items == undefined){ newErrors.items = []; }
        newErrors.items.push(_errDescGlob);
        errorToast.push("- " + _errDescGlob);
        setButtonDisabled(false);
      }
    }
    // ── (2026-07-22 Viajes) Nodo `/viajes` — ESPEJO de las reglas del backend ──
    // Fuentes: factura_routes._parse_viajes (obligatoriedad + longitudes +
    // mayúscula de tipo_identificacion) y factura_routes._gate_agencia_viajes
    // (la empresa emisora debe tener es_agencia_viajes activo).
    {
      const _viajes = preInvoice.viajes || [];
      const _esBoleteria = !!preInvoice.es_boleteria_aerea;
      const _pushViaje = (msg) => {
        if (newErrors.viajes == undefined){ newErrors.viajes = []; }
        newErrors.viajes.push(msg);
        errorToast.push("- " + msg);
        setButtonDisabled(false);
        // La sección es colapsable: si hay errores se abre para que el usuario
        // vea el detalle junto al campo, no solo en el toast.
        setViajesAbierto(true);
      };
      // Un boleto SIN ningún dato no se persiste (el backend lo descarta): para
      // contar "al menos un boleto" solo valen los que tienen algún dato.
      const _conDatos = _viajes.filter(viajeTieneDatos);
      // D1 nivel 1: la empresa emisora debe estar habilitada como agencia.
      // Solo se bloquea si CONSTA que no lo está (=== false); con la marca
      // desconocida (null) se deja pasar y decide el backend.
      if ((_esBoleteria || _conDatos.length > 0) && empresaEsAgenciaViajes === false) {
        _pushViaje("Los datos de viaje requieren que la empresa emisora esté habilitada como agencia de viajes.");
      }
      // D1 nivel 2: con boletería aérea marcada se exige al menos un boleto.
      if (_esBoleteria && _conDatos.length === 0) {
        _pushViaje("Debe ingresar al menos un boleto cuando el documento es boletería aérea.");
      }
      for (let v = 0; v < _viajes.length; v++) {
        const _viaje = _viajes[v] || {};
        const _nro = v + 1;
        for (let c = 0; c < VIAJE_CAMPOS.length; c++) {
          const _campo = VIAJE_CAMPOS[c];
          const _valor = String(_viaje[_campo.key] ?? '').trim();
          // Obligatoriedad: con boletería aérea los 15 campos son obligatorios
          // ("en dado caso que sea boletería aérea cada uno de los campos es
          // obligatorio", norma L541).
          if (_esBoleteria && _valor === '') {
            _pushViaje(`Boleto #${_nro}: ${_campo.label} es obligatorio por ser boletería aérea.`);
            continue;
          }
          if (_valor === '') continue;
          // Longitud máxima (el backend recorta en silencio; aquí se avisa).
          if (_valor.length > _campo.max) {
            _pushViaje(`Boleto #${_nro}: ${_campo.label} no puede superar los ${_campo.max} caracteres.`);
          }
          // tipo_identificacion: un (1) carácter y en MAYÚSCULA (norma L543).
          if (_campo.key === 'tipo_identificacion' &&
              (_valor.length !== 1 || _valor !== _valor.toUpperCase())) {
            _pushViaje(`Boleto #${_nro}: ${_campo.label} debe ser un (1) carácter en mayúscula.`);
          }
          // numero_identificacion: solo dígitos, máximo 12.
          if (_campo.key === 'numero_identificacion' && !/^\d{1,12}$/.test(_valor)) {
            _pushViaje(`Boleto #${_nro}: ${_campo.label} debe contener solo dígitos (máximo ${_campo.max}).`);
          }
          // (2026-07-22, decisión del cliente) FORMATO de fechas y horas.
          // La norma NO fija formato para estos campos ni les asigna código de
          // rechazo, y el backend los guarda y emite LITERALES. Sin validación,
          // cada usuario escribiría a su manera ('22/07/2026', '22-07-26',
          // '2026-07-22') y ese texto viajaría tal cual al documento fiscal,
          // dejando los reportes inconsistentes entre documentos. Se exige el
          // mismo formato que el resto del sistema ya emite: dd/MM/AAAA para la
          // fecha y hh:mm:ss am/pm (12 h) para la hora — coherente con
          // `fechaEmision` y `horaEmision` del encabezado.
          if ((_campo.key === 'fecha_salida' || _campo.key === 'fecha_llegada') &&
              !/^\d{2}\/\d{2}\/\d{4}$/.test(_valor)) {
            _pushViaje(`Boleto #${_nro}: ${_campo.label} debe tener el formato DD/MM/AAAA.`);
          }
          if ((_campo.key === 'hora_salida' || _campo.key === 'hora_llegada') &&
              !/^(0[1-9]|1[0-2]):[0-5]\d:[0-5]\d (am|pm)$/.test(_valor)) {
            _pushViaje(`Boleto #${_nro}: ${_campo.label} debe tener el formato HH:MM:SS am/pm (12 horas), por ejemplo 08:30:00 am.`);
          }
        }
      }
    }
    if (preInvoice.tipo_documento == 'ND' && preInvoice.items.length == 0 && preInvoice.conceptos_nd.length == 0) {
      if (newErrors.items == undefined){
        newErrors.items = [];
      }
      newErrors.items.push("Debe ingresar las lineas o los conceptos del documento.");
      errorToast.push("- Debe ingresar las lineas o los conceptos del documento.");
      //toast.error("Debe ingresar las lineas o los conceptos del documento.");
      setButtonDisabled(false);
      //return;
    }
    if (preInvoice.conceptos_nd){
      for (var i = 0; i < preInvoice.conceptos_nd.length; i++){
        if (!preInvoice.conceptos_nd[i].concepto) {
          if (newErrors.items == undefined){
            newErrors.items = [];
          }
          newErrors.items.push("No se pueden procesar conceptos sin descripción.");
          errorToast.push("- No se pueden procesar conceptos sin descripción.");
          //toast.error("No se pueden procesar conceptos sin descripción.");
          setButtonDisabled(false);
          //return;
        }
        if (preInvoice.conceptos_nd[i].monto <= 0) {
          if (newErrors.items == undefined){
            newErrors.items = [];
          }
          newErrors.items.push("No se pueden procesar los conceptos con monto menor o igual que 0.");
          errorToast.push("- No se pueden procesar los conceptos con monto menor o igual que 0.");
          //toast.error("No se pueden procesar los conceptos con monto menor o igual que 0.");
          setButtonDisabled(false);
          //return;
        }
      }
    }
    if (preInvoice.pagos.length == 0) {
      if (newErrors.pagos == undefined){
        newErrors.pagos = [];
      }
      newErrors.pagos.push("Los pagos son obligatorios");
      errorToast.push("- Debe ingresar los pagos del documento.");
      //toast.error("Debe ingresar las lineas del documento.");
      setButtonDisabled(false);
      //return;
    }
    // (2026-05-14) Multi-moneda: cada pago lleva `tasa_actual` (factor para
    // convertir monto del pago a la moneda de la proforma). La suma se
    // construye en la moneda de la proforma. Si por algun motivo un pago
    // no tiene tasa_actual (fila vieja, sin metodo elegido), se asume 1.
    var totalPaidEnProforma = 0;
    for (var i = 0; i < preInvoice.pagos.length; i++){
      if (!preInvoice.pagos[i].metodo_pago_codigo || preInvoice.pagos[i].metodo_pago_codigo == '') {
        if (newErrors.pagos == undefined){
          newErrors.pagos = [];
        }
        newErrors.pagos.push("No se pueden procesar pagos sin medio de pago especificado.");
        errorToast.push("- No se pueden procesar pagos sin medio de pago especificado.");
        setButtonDisabled(false);
      }
      if (!preInvoice.pagos[i].aplica_igtf && (!preInvoice.pagos[i].banco || preInvoice.pagos[i].banco == '')) {
        if (newErrors.pagos == undefined){
          newErrors.pagos = [];
        }
        newErrors.pagos.push("No se pueden procesar pagos sin el banco especificado.");
        errorToast.push("- No se pueden procesar pagos sin el banco especificado.");
        setButtonDisabled(false);
      }
      if (preInvoice.pagos[i].monto <= 0) {
        if (newErrors.pagos == undefined){
          newErrors.pagos = [];
        }
        newErrors.pagos.push("No se pueden procesar pagos con monto menor o igual que 0.");
        errorToast.push("- No se pueden procesar pagos con monto menor o igual que 0.");
        setButtonDisabled(false);
      }else{
        const monto = Number(preInvoice.pagos[i].monto) || 0;
        const tasa = Number(preInvoice.pagos[i].tasa_actual) || 1;
        totalPaidEnProforma = totalPaidEnProforma + (monto * tasa);
      }
    }
    if (preInvoice.pagos.length > 0) {
      const totalPaid = Math.max(0, roundTo(totalPaidEnProforma, 2));
      const totalInvoice = Math.max(0, roundTo((totalAmount + igtfAmount), 2));
      console.log('validate-totalPaid(en moneda proforma): ', totalPaid);
      console.log('validate-totalInvoice: ', totalInvoice);
      // Tolerancia de 0,05 unidades en la moneda de la proforma para absorber
      // redondeos del helper de conversion y de las tasas BCV.
      if (Math.abs(totalPaid - totalInvoice) > 0.05){
        if (newErrors.pagos == undefined){
          newErrors.pagos = [];
        }
        newErrors.pagos.push("Diferencia encontrada en el total y los pagos registrados.");
        errorToast.push("- Diferencia encontrada en el total y los pagos registrados.");
        setButtonDisabled(false);
      }
    }
    //console.log('newErrors: ', newErrors);
    setErrors(newErrors);
    //console.log('errorToast: ', errorToast);
    if (errorToast.length > 0){
      //toast.error(errorToast);
      toast.error(<div>
        {errorToast.map(item => (
            <span className="text-start">{item}<br/></span>
          ))}
      </div>)
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aquí enviarías los datos de nuevo al backend para actualizar al preInvoice
    setButtonDisabled(true); // Iniciar carga (deshabilitar botón)
    //console.log("preInvoice(I):", preInvoice);
    if (!validate()) return;
    //console.log("preInvoiceId:", preInvoiceId);
    // (2026-07-22 Viajes) Si la sección de boletos no aplica, las claves del
    // nodo `/viajes` NO viajan en el payload. Importa: el backend trata una
    // lista (incluso vacía) como REEMPLAZO y registraría 'viajes' como campo
    // modificado en cada PUT. Sin sección => payload idéntico al de hoy.
    if (!mostrarSeccionViajes) {
      delete preInvoice.es_boleteria_aerea;
      delete preInvoice.viajes;
    }
    // (2026-08-02, ítem 30-ii) EXCLUSIVIDAD del descuento EN EL PAYLOAD y
    // limpieza de los campos que son solo de pantalla. Toda la regla vive en
    // `aplicarDescuentoPayloadItems` (helper de módulo, probado): en modo
    // "monto fijo" `descuento_porcentaje` viaja como NULL (no 0) porque un 0
    // explícito hace que el backend tome el porcentaje y descarte el monto
    // (utils.py:565), y ese campo está fuera de la coerción ''|null -> 0
    // (servicios_compartidos.py:47-55), de modo que el NULL llega intacto.
    aplicarDescuentoPayloadItems(preInvoice.items);
    // (2026-08-02, ítem 29-ii) Correlativo interno: NULL (no "") cuando el
    // emisor opera en NumeracionAutomatica. Ver `correlativoParaPayload`.
    preInvoice.correlativo_interno = correlativoParaPayload(
      preInvoice.correlativo_interno, correlativoAutomatico,
    );
    try {
      var data;
      var action;
      if (preInvoice.id == '#'){
        delete preInvoice.id;
        if (preInvoice.cliente_id == '#'){
          delete preInvoice.cliente_id;
        }
        if (preInvoice.tipo_documento != 'ND'){
          delete preInvoice.conceptos_nd;
        }
        for (var i = 0; i < preInvoice.items.length; i++){
          delete preInvoice.items[i].id;
        }
        action = 'create';
        //preInvoice.total = totalAmount;
        //console.log("preInvoice(F):", preInvoice);
        // (2026-05-22) Encapsular los datos del cliente en el objeto
        // `cliente` — formato que ahora espera el servicio de creación
        // de proformas. `cliente_id` se mantiene plano (lo usa el backend
        // para resolver un cliente existente). Los campos planos
        // cliente_rif/nombre/telefono/email/direccion se reemplazan por
        // el objeto anidado.
        preInvoice.cliente = {
          rif: preInvoice.cliente_rif || undefined,
          nombre: preInvoice.cliente_nombre || undefined,
          telefono: preInvoice.cliente_telefono || undefined,
          email: preInvoice.cliente_email || undefined,
          direccion: preInvoice.cliente_direccion || undefined,
        };
        delete preInvoice.cliente_rif;
        delete preInvoice.cliente_nombre;
        delete preInvoice.cliente_telefono;
        delete preInvoice.cliente_email;
        delete preInvoice.cliente_direccion;
        var preInvoiceList = [preInvoice];
        if (rol == 'admin'){
          var empresa_id = preInvoice.empresa_id;
          delete preInvoice.empresa_id;
          delete preInvoice.cliente_rif;
          delete preInvoice.cliente_nombre;
          data = await createPreInvoice(preInvoiceList, empresa_id); // Llamamos a createClient con el ID
        }else{
          data = await createPreInvoice(preInvoiceList); // Llamamos a createClient con el ID
        }
        //console.log("preInvoice(F)-data:", data);
      }else{
        action = 'update';
        data = await editPreInvoice(decryptText(preInvoiceId), preInvoice); // Llamamos a editPreInvoice con el ID
      }
      console.log('editPreInvoice-data: ', data);
      //setPreInvoice(data.resultados[0]); // Guardamos los datos del preInvoice en el estado
      // Mostrar una notificación de éxito
      //console.log(action +'-status: ', data);
      if (data.resultados != undefined && action == 'create' && data.resultados[0].status == 'prefactura_creada'){
        //console.log('CreatePreInvoice-toast:==>');
        toast.success('Proformas creada satisfactoriamente.', {
          onClose: () => {
            // Espera a que la notificación se cierre para redirigir
            setTimeout(() => {
              navigate("/proformas");  // Redirige a la lista de pre-facturas
            }, 2000); // El tiempo debe ser el mismo o ligeramente mayor que la duración de la notificación
          },
        });
      } else if (action == 'update' && ((data.items != undefined && data.items.length) > 0 || data.mensaje == 'No se enviaron campos modificables o los valores son iguales.')){
        //console.log('EditPreInvoice-toast:==>');
        toast.success('Proformas actualizada satisfactoriamente.', {
          onClose: () => {
            // Espera a que la notificación se cierre para redirigir
            setTimeout(() => {
              navigate("/proformas");  // Redirige a la lista de pre-facturas
            }, 2000); // El tiempo debe ser el mismo o ligeramente mayor que la duración de la notificación
          },
        });
      }else if (data.error != undefined){
        toast.error(data.error);
        setButtonDisabled(false);
      }else{
        //console.log('EditPreInvoice-Error:==>');
        if (action == 'create'){
          preInvoice.id = '#';
        }
        for (var i = 0; i < preInvoice.items.length; i++){
          preInvoice.items[i].id = i + 1;
        }
        toast.error(data.resultados[0].motivo);
        setButtonDisabled(false);
      }
    } catch (err) {
      console.log('Error: ', err);
      setError('Error al cargar la Proformas');
      // Mostrar una notificación de error
      toast.error("Error al actualizar la Proformas");  // Notificación de error
      setButtonDisabled(false);
    } finally {
      setLoading(false); // Indicamos que la carga ha finalizado
    }
  };

  const redirectToList = () => {
    navigate(`/proformas`);
  };

  // Agregar nueva línea con foco
  const handleAddRow = () => {
    const newId =
      preInvoice.items.length > 0
        ? Math.max(...preInvoice.items.map((r) => r.id)) + 1
        : 1;
    //console.log('newId: ', newId);
    // (2026-08-02, ítem 30-ii) La línea nace en modo PORCENTAJE (comportamiento
    // histórico) con el monto fijo en 0 y sin concepto de descuento.
    const newRow = { id: newId, nueva_linea: true, producto_id: "", cantidad: 1, precio_unitario: 0, iva_categoria_id: "", tasa_porcentaje: "", descuento_tipo: 'porcentaje', descuento_porcentaje: 0, descuento_monto: 0, descuento_nombre: "", recargo_monto: 0 };

    setPreInvoice((prev) => {
      const updated = {
        ...prev,
        items: [...prev.items, newRow],
      };

      setTimeout(() => {
        try{
          apiRef.current.setCellFocus(newId, "producto_id");
          apiRef.current.startCellEditMode({ id: newId, field: "producto_id" });
        }catch (err) {
          console.log('Error: ', err);
        }
      });

      return updated;
    });
  };

  // Agregar nueva línea con foco Nota de Debito
  const handleAddRowNd = () => {
    const newId =
      preInvoice.conceptos_nd.length > 0
        ? Math.max(...preInvoice.conceptos_nd.map((r) => r.id)) + 1
        : 1;
    //console.log('newId: ', newId);
    const newRow = { id: newId, nueva_linea: true, concepto: "", tasa_porcentaje: 16.0, monto: 0.0 };

    setPreInvoice((prev) => {
      const updated = {
        ...prev,
        conceptos_nd: [...prev.conceptos_nd, newRow],
      };

      setTimeout(() => {
        apiRefNd.current.setCellFocus(newId, "concepto");
        apiRefNd.current.startCellEditMode({ id: newId, field: "concepto" });
      });

      return updated;
    });
  };

  // ← AGREGAR NUEVA LÍNEA DE PAGO
  const handleAddRowMp = () => {
    // ← VALIDACIÓN 1: Calcular monto restante ANTES de agregar
    const totalPagadoActual = preInvoice.pagos.reduce((sum, pago) => {
      return sum + (Number(pago.monto) || 0);
    }, 0);

    const montoRestante = Math.max(0, roundTo((totalAmount + igtfAmount) - totalPagadoActual, 2));

    // ← NUEVA VALIDACIÓN: No agregar si no hay monto restante
    if (montoRestante <= 0) {
      toast.error('No hay saldo pendiente por cancelar');
      return; // ← NO agregar la línea
    }

    const newId = preInvoice.pagos.length > 0
      ? Math.max(...preInvoice.pagos.map((r) => r.id)) + 1
      : 1;

    const newRow = {
      id: newId,
      nueva_linea: true,
      metodo_pago_codigo: "",
      monto: montoRestante,  // Monto restante por defecto
      banco: ''
    };

    setPreInvoice((prev) => {
      const updated = {
        ...prev,
        pagos: [...prev.pagos, newRow],
      };

      setTimeout(() => {
        try {
          apiRefMp.current.setCellFocus(newId, "metodo_pago_codigo");
          apiRefMp.current.startCellEditMode({ id: newId, field: "metodo_pago_codigo" });
        } catch (err) {
          console.log('Error:', err);
        }
      });

      return updated;
    });
  };

  // Función para eliminar fila
  const handleDeleteRow = (id) => {
    setPreInvoice((prev) => ({
      ...prev,
      items: prev.items.filter((row) => row.id !== id),
    }));
  };

  // Función para eliminar fila del concepto en nota de debito
  const handleDeleteRowNd = (id) => {
    setPreInvoice((prev) => ({
      ...prev,
      conceptos_nd: prev.conceptos_nd.filter((row) => row.id !== id),
    }));
  };

  // Función para eliminar fila del medio de pago
  const handleDeleteRowMp = (id) => {
    setPreInvoice((prev) => ({
      ...prev,
      pagos: prev.pagos.filter((row) => row.id !== id),
    }));
  };

  // (2026-05-14) Conversion de precio entre monedas.
  // El precio_base del producto esta expresado en la moneda_extranjera del
  // emisor (cliente propietario del producto). La proforma puede emitirse
  // en VES, USD o EUR (cualquier moneda activa). Calculamos el precio en la
  // moneda elegida usando las tasas BCV del dia (latestExchangeRateHistory).
  //
  //   - moneda_proforma == moneda_extranjera_del_emisor: sin conversion.
  //   - moneda_proforma == VES: precio_base * tasa[moneda_extranjera].
  //   - moneda_proforma == otra extranjera (cross-rate):
  //       (precio_base * tasa[moneda_extranjera]) / tasa[moneda_proforma].
  //   - moneda_origen == VES (caso raro): precio_base / tasa[moneda_proforma].
  // Si falta algun dato (sin tasas o sin codigos), devolvemos el precio sin
  // tocar — el operador podra ajustarlo manualmente.
  const convertirPrecio = (precioBase, monedaOrigenCodigo, monedaDestinoCodigo) => {
    const base = parseFloat((precioBase || 0).toString().replace(',', '.')) || 0;
    const origen = (monedaOrigenCodigo || '').toUpperCase();
    const destino = (monedaDestinoCodigo || '').toUpperCase();
    if (!origen || !destino || origen === destino) return base;
    const tasas = latestExchangeRateHistory?.tasas || {};
    if (destino === 'VES') {
      const tasa = Number(tasas[origen]?.tasa);
      if (!tasa) return base;
      return base * tasa;
    }
    if (origen === 'VES') {
      const tasa = Number(tasas[destino]?.tasa);
      if (!tasa) return base;
      return base / tasa;
    }
    const tasaOrigen = Number(tasas[origen]?.tasa);
    const tasaDestino = Number(tasas[destino]?.tasa);
    if (!tasaOrigen || !tasaDestino) return base;
    return (base * tasaOrigen) / tasaDestino;
  };

  // Función para actualizar fila
const processRowUpdate = (newRow, oldRow) => {
  // (2026-08-03, P4/T3) GUARDA DURA de la línea de comisión de tercero: se
  // devuelve la fila ORIGINAL sin aplicar nada. Va aquí —y no solo en
  // `isCellEditable`— a propósito: si alguien reintrodujera `editable: true` sin
  // la guarda por fila, o si la edición llegara por otra vía del DataGrid, el
  // monto seguiría siendo el que calcula el sistema. La comisión es un importe
  // derivado; editarla a mano descuadraría el documento contra los pagos y
  // contra el recálculo del backend (400 con esperado/recibido).
  if (esLineaComisionTercero(oldRow) || esLineaComisionTercero(newRow)) {
    return oldRow;
  }
  // Buscar producto seleccionado
  const selectedProduct = products?.find(p => p.id === newRow.producto_id);

  // Normalizar precio_base: convertir "31,00" -> 31.00 (float)
  let precioUnitario = newRow.precio_unitario;

  // (2026-05-14) Solo recalcular el precio cuando el producto cambia (o no
  // hay precio aun). Si el usuario edito manualmente el precio, NO se pisa.
  if (selectedProduct && (oldRow.producto_id !== newRow.producto_id || !precioUnitario)) {
    const monedaProformaCodigo = (preInvoice?.moneda?.codigo || '').trim().toUpperCase();
    precioUnitario = convertirPrecio(
      selectedProduct.precio_base,
      monedaExtranjeraCodigo,
      monedaProformaCodigo,
    );
  }

  // (2026-05-22) Redondear precio_unitario a 2 decimales. El backend
  // aplica quantize(0.01) al precio unitario al recalcular la proforma;
  // si el frontend conserva la precision flotante completa de la
  // conversion de moneda (p.ej. 4.6108300007554055), sus totales —y por
  // ende la suma de pagos— difieren del total recalculado por el backend,
  // y la creacion falla con "la suma de pagos no coincide con el total".
  const precioUnitario2dec = roundTo(
    parseFloat(String(precioUnitario).replace(',', '.')) || 0,
    2,
  );

  // (2026-08-02, ítem 30-ii) EXCLUSIVIDAD del descuento de línea. El backend da
  // precedencia al porcentaje cuando no es NULL (utils.py:565-575): si las dos
  // columnas quedaran con valor, el monto fijo se perdería en silencio. Al
  // elegir un tipo se LIMPIA la columna del otro, de modo que lo que se ve en
  // pantalla es exactamente lo que se envía.
  const _tipoDesc = tipoDescuentoLinea(newRow);
  const _descPct = _tipoDesc === 'monto' ? 0 : (Number(newRow.descuento_porcentaje) || 0);
  const _descMonto = _tipoDesc === 'monto' ? (Number(newRow.descuento_monto) || 0) : 0;

  // Crear la fila actualizada
  const updatedRow = {
    ...newRow,
    precio_unitario: precioUnitario2dec,
    descuento_tipo: _tipoDesc,
    descuento_porcentaje: _descPct,
    descuento_monto: _descMonto,
    // Convención UpperCase en los inputs de texto del proyecto.
    descuento_nombre: newRow.descuento_nombre
      ? String(newRow.descuento_nombre).toUpperCase()
      : newRow.descuento_nombre,
    // (2026-08-02) GUARDA: `selectedProduct` es undefined cuando la línea aún no
    // tiene producto o cuando el producto de una proforma cargada no está en el
    // catálogo en memoria (inactivo, de otro tercero…). Sin esta guarda,
    // `selectedProduct.iva_categoria.id` lanzaba TypeError y la edición de
    // CUALQUIER celda de esa fila se perdía. Se conservan los valores previos.
    iva_categoria_id: selectedProduct ? selectedProduct.iva_categoria.id : newRow.iva_categoria_id,
    tasa_porcentaje: selectedProduct ? selectedProduct.iva_categoria.tasa_porcentaje : newRow.tasa_porcentaje,
  };

  // Actualizar estado global preInvoice
  setPreInvoice((prev) => ({
    ...prev,
    items: prev.items.map((row) =>
      row.id === updatedRow.id ? updatedRow : row
    ),
  }));

  return updatedRow; // obligatorio retornar la fila actualizada
};

  // Función para actualizar fila Nota Debito
const processRowUpdateNd = (newRow, oldRow) => {
  // Buscar producto seleccionado

  // Normalizar precio_base: convertir "31,00" -> 31.00 (float)
  let monto = parseFloat(
    newRow.monto.toString().replace(",", ".")
  );

  // Crear la fila actualizada
  const updatedRow = {
    ...newRow,
    monto: monto,
  };

  // Actualizar estado global preInvoice
  setPreInvoice((prev) => ({
    ...prev,
    conceptos_nd: prev.conceptos_nd.map((row) =>
      row.id === updatedRow.id ? updatedRow : row
    ),
  }));

  return updatedRow; // obligatorio retornar la fila actualizada
};

const processRowUpdateMp = (newRow, oldRow) => {
  try {
    const selectedPaymentMethod = paymentMethods?.find(p => p.codigo === newRow.metodo_pago_codigo) || null;

    // Moneda del metodo de pago (USD/EUR/VES) y de la proforma. Se usan para
    // convertir el monto entre ambas: el monto editable esta en la moneda
    // del metodo, los totales/saldo de la proforma estan en su propia moneda.
    const monedaPagoCodigo = (selectedPaymentMethod?.moneda?.codigo || '').toUpperCase();
    const monedaProformaCodigo = (preInvoice?.moneda?.codigo || '').toUpperCase();

    let monto = 0;
    if (newRow.monto != null && newRow.monto !== '') {
      monto = parseFloat(newRow.monto?.toString().replace(",", ".") || "0");
      if (isNaN(monto)) monto = 0;
    }

    // (2026-05-14) Saldo restante en la moneda de la proforma. Para sumar
    // los pagos previos correctamente, cada uno se convierte a la moneda
    // de la proforma usando la tasa BCV del dia.
    const totalPagadoEnProformaMoneda = (preInvoice?.pagos || []).reduce((sum, pago) => {
      if (pago.id === newRow.id) return sum; // excluir la fila editada
      const mp = paymentMethods?.find(p => p.codigo === pago.metodo_pago_codigo);
      const monPag = (mp?.moneda?.codigo || monedaProformaCodigo || '').toUpperCase();
      const enProforma = convertirPrecio(Number(pago.monto) || 0, monPag, monedaProformaCodigo);
      return sum + enProforma;
    }, 0);

    const montoRestanteEnProforma = roundTo(
      (totalAmount + igtfAmount) - totalPagadoEnProformaMoneda,
      2,
    );

    // (2026-05-14) Auto-sugerencia: si el metodo cambia (o el monto estaba
    // vacio/cero), llenamos `monto` con el saldo restante convertido a la
    // moneda del metodo de pago. El usuario puede sobreescribirlo despues.
    //   Ej.: proforma en VES total 4 000 Bs, metodo USD (tasa 40) -> 100 USD
    //        proforma en USD total 100,   metodo EUR (tasa USD=40, EUR=44) -> 90,91 EUR
    const metodoCambio = oldRow.metodo_pago_codigo !== newRow.metodo_pago_codigo;
    if (selectedPaymentMethod && (metodoCambio || !monto)) {
      const sugerido = convertirPrecio(
        montoRestanteEnProforma,
        monedaProformaCodigo,
        monedaPagoCodigo,
      );
      if (sugerido > 0) monto = roundTo(sugerido, 2);
    }

    // (2026-05-14) Tope: convertir el monto a moneda de la proforma y comparar
    // contra el saldo restante. Si excede, ajustar al maximo permitido.
    const montoEnProforma = convertirPrecio(monto, monedaPagoCodigo, monedaProformaCodigo);
    if (montoEnProforma > montoRestanteEnProforma) {
      const ajustado = convertirPrecio(
        montoRestanteEnProforma,
        monedaProformaCodigo,
        monedaPagoCodigo,
      );
      monto = roundTo(ajustado, 2);
      toast.info(`Monto ajustado al saldo restante: ${formatMoney(monto, selectedPaymentMethod?.moneda)}`);
    }

    // ← LIMPIAR BANCO si aplica IGTF
    const banco = selectedPaymentMethod?.aplica_igtf ? '' : (newRow.banco || '');

    const aplicaIgtf = selectedPaymentMethod ? selectedPaymentMethod.aplica_igtf : false;

    // (2026-05-14) tasa_actual: factor multiplicativo que convierte 1 unidad
    // de la moneda del metodo de pago en la moneda de la proforma. Permite
    // que validate() compare la suma de pagos vs el total sin re-cotizar:
    //   monto_en_proforma = monto * tasa_actual
    // Casos:
    //   - Misma moneda: 1
    //   - Pago divisa + proforma VES: tasa BCV [divisa] (VES por unidad)
    //   - Pago VES + proforma divisa: 1 / tasa BCV [divisa de la proforma]
    //   - Cross-rate (pago divisa A, proforma divisa B): tasa[A] / tasa[B]
    let tasaActual = 1;
    if (monedaPagoCodigo && monedaProformaCodigo && monedaPagoCodigo !== monedaProformaCodigo) {
      const tasas = latestExchangeRateHistory?.tasas || {};
      if (monedaProformaCodigo === 'VES') {
        const t = Number(tasas[monedaPagoCodigo]?.tasa);
        if (t) tasaActual = t;
      } else if (monedaPagoCodigo === 'VES') {
        const t = Number(tasas[monedaProformaCodigo]?.tasa);
        if (t) tasaActual = 1 / t;
      } else {
        const tA = Number(tasas[monedaPagoCodigo]?.tasa);
        const tB = Number(tasas[monedaProformaCodigo]?.tasa);
        if (tA && tB) tasaActual = tA / tB;
      }
    }

    const updatedRow = {
      ...newRow,
      monto: Number(monto.toFixed(2)),
      aplica_igtf: aplicaIgtf,
      banco: banco,
      tasa_actual: tasaActual,
    };

    setPreInvoice((prev) => {
      if (!prev || !prev.pagos) return prev;
      const updatedPagos = prev.pagos.map((row) =>
        row.id === updatedRow.id ? updatedRow : row
      );
      return { ...prev, pagos: updatedPagos };
    });

    return updatedRow;
  } catch (error) {
    console.error('Error en processRowUpdateMp:', error);
    return oldRow || newRow;
  }
};

// (2026-08-03, ronda 2 / T1) Máscara del R.I.F. del CLIENTE de la proforma.
// La clase de letras es `[VJEPGC]`, portada EXACTAMENTE de
// components/Clients/FormClients.js:716 (el maestro): la 'C' (Comunal) entró por
// decisión del usuario y `utils.validar_rif` la admite
// (`^[VEJGPC]-\d{8}-\d$`, utils.py:351).
// POR QUÉ IMPORTA: sin la C, la máscara BORRA la letra en la primera pulsación
// (`if (!/[VJEPG…]/.test(value)) value = ""`), así que el operador no puede
// TECLEAR el RIF de un cliente comunal aunque el backend lo acepte. Ampliar
// validar_rif sin ampliar las máscaras deja el bug vivo en la capa web.
const handleSearchRif = (value, type) => {
  //console.log('handleSearchRif-value: ', value);
  //console.log('handleSearchRif-type: ', type);
  value = value.toUpperCase();

  // Elimina caracteres no válidos (solo letras, números y guiones)
  value = value.replace(/[^A-Z0-9-]/g, "");

  // Forzar el patrón paso a paso
  if (value.length === 1) {
    // Primera posición → solo letras válidas
    if (!/[VJEPGC123456789]/.test(value)) value = "";
  } else if (value.length === 2) {
      // Solo agregar guion si comienza con letra válida
      if (/[VJEPGC]/.test(value[0]) && !value.includes("-")) {
        value = value[0] + "-" + value[1];
      }
    } else if (value.length > 2) {
    // Nuevo: permitir solo números (hasta 8)
    const matchSoloNumeros = value.match(/^\d{0,8}$/);

    if (matchSoloNumeros) {
      value = matchSoloNumeros[0];
    } else {
      // Caso RIF tradicional
      const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);

      if (match) {
        const [, letra, numeros, verificador] = match;
        value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
      } else {
        value = type == 'admin' ? preInvoice.cliente_rif : preInvoice.cliente_rif;
      }
    }
  }

  // Actualiza el campo
  if (type == 'admin'){
    setPreInvoice((prev) => ({ ...prev, cliente_rif: value }));
  }else{
    setPreInvoice((prev) => ({ ...prev, cliente_rif: value }));
  }

  if (value.length < 2) {
    if (type == 'admin'){
      setFilterResultsAdmin([]);
    }else{
      setFilterResults([]);
    }
    return;
  }
  var results;
  if (type == 'admin'){
    //console.log('clients: ', clients);
    results = clients.filter((c) =>
      c.rif.toUpperCase().includes(value) ||
      c.nombre_empresa.toUpperCase().includes(value)
    );
  }else{
    //console.log('endClients: ', endClients);
    results = endClients.filter((c) =>
      c.rif.toUpperCase().includes(value) ||
      c.nombre.toUpperCase().includes(value)
    );
  }
  //console.log('handleSearchRif-results.length: ', results.length);
  if (results.length == 0){
    $('#div_none_endclients').attr('style', "width: 600px;");
    $('.form-client-complement').addClass('mt-10');
    if (type == 'admin'){
      setPreInvoice((prev) => ({
      ...prev,
        cliente_id: '#',
        //cliente_rif: '',
        cliente_nombre: '',
      }));
    }else{
      setPreInvoice((prev) => ({
      ...prev,
        cliente_id: '#',
        //cliente_rif: '',
        cliente_nombre: '',
        cliente_telefono: '',
        cliente_email: '',
        cliente_direccion: '',
      }));
    }

  }else{
    $('#div_none_endclients').removeAttr('style');
    $('.form-client-complement').removeClass('mt-10');
  }
  if (type == 'admin'){
    setFilterResultsAdmin(results);
  }else{
    setFilterResults(results);
  }
  setFilterResults(results);
  setShowResults(true);
};

const selectClient = async (client, type) => {
  if (type == 'admin'){
    //console.log('selectClient-client: ', client);
    // (2026-05-14) Capturar moneda_extranjera del emisor seleccionado para
    // la conversion de precios de productos.
    const monExt = client.moneda_extranjera && client.moneda_extranjera.codigo
      ? (client.moneda_extranjera.codigo || '').trim().toUpperCase()
      : null;
    setMonedaExtranjeraCodigo(monExt);
    // (2026-05-14) Al cambiar de emisor, default de moneda de la proforma =
    // moneda_designada del emisor (si existe); cae a VES.
    const monDesId = client.moneda_designada_id || 3;
    const monDesObj = client.moneda_designada || null;
    // (2026-07-22 Viajes) D1 nivel 1: la habilitacion de agencia de viajes es
    // del EMISOR. Al cambiar de emisor se re-evalua la visibilidad de la
    // seccion de boletos y se limpian los datos de viaje ya cargados (el gate
    // del backend valida contra la empresa emisora final).
    setEmpresaEsAgenciaViajes(!!client.es_agencia_viajes);
    // (2026-08-02, ítem 29-ii) Modo de operación del EMISOR seleccionado por el
    // admin. `tipo_operacion` ya viaja en el objeto de empresa (EmpresaSchema);
    // aquí se descartaba. Si el emisor no lo trae se vuelve a "desconocido"
    // (correlativo visible y obligatorio: el comportamiento conservador).
    setModoOperacionEmisor(client.tipo_operacion || null);
    // (2026-08-03, P4/T3) Regla de facturación del EMISOR seleccionado. Al
    // cambiar de emisor se RESETEA (igual que doc_tercero/tercero_id justo
    // abajo) para no arrastrar la 'Combinada' del emisor anterior; también se
    // suelta el producto de comisión cacheado, que es de aquel emisor.
    setReglaFacturacionEmisor(client.regla_facturacion || null);
    setProductoComisionEmisor(null);
    setPreInvoice((prev) => ({
      ...prev,
      empresa_id: client.id || '#',
      cliente_rif: client.rif || '',
      cliente_nombre: client.nombre_empresa || '',
      // Al cambiar de emisor, resetear el flujo de tercero para que el operador
      // re-confirme la decision con la nueva lista de terceros.
      doc_tercero: false,
      tercero_id: null,
      moneda_id: monDesId,
      moneda: monDesObj,
      // (2026-07-22 Viajes) reset del nodo /viajes al cambiar de emisor.
      es_boleteria_aerea: false,
      viajes: [],
    }));
    if (client && client.id){
      //console.log('selectClient-filterResultsAdmin: ', filterResultsAdmin[0]);
      const datacls = await getEndClients({ client_id: client.id });
      setEndClients(datacls.data);
      const datapts = await getProducts({ client_id: client.id });
      setProducts(datapts);

      // (2026-05-13) Req1 P2e: si el cliente emisor seleccionado por el admin
      // tiene es_emisor=true, traer sus terceros activos (padre_id=client.id)
      // y habilitar el toggle 'doc_tercero'. Si no, ocultar la opcion.
      const esEmisor = !!client.es_emisor;
      setClienteEmisorEsEmisor(esEmisor);
      if (esEmisor) {
        const datatcs = await getClients({ es_tercero: true, padre_id: client.id, activo: true });
        setTerceros(normalizeClientsResponse(datatcs));
      } else {
        setTerceros([]);
      }
    }
  }else{
    setPreInvoice((prev) => ({
      ...prev,
      cliente_id: client.id || '#',
      cliente_rif: client.rif || '',
      cliente_nombre: client.nombre || '',
      cliente_telefono: client.telefono || '',
      cliente_email: client.email || '',
      cliente_direccion: client.direccion || '',
      zona: client.zona || '',
    }));
  }
  if (type == 'admin'){
    setFilterResultsAdmin([]);
  }else{
    setFilterResults([]);
  }
  setShowResults(false);
};

const reduceRif = (rif, type) => {
  if (type == 'admin'){
    setPreInvoice((prev) => ({
      ...prev,
      cliente_rif: rif || '',
    }));
  }else{
    setPreInvoice((prev) => ({
      ...prev,
      cliente_rif: rif || '',
    }));
  }
};

const handleRadioChange = (event) => {
  setSelectedView(event.target.value); // Actualiza el estado con el valor del radio button seleccionado
};

  return (
    <div className="mx-auto w-full">
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* Colocamos el contenedor de las notificaciones */}
            <ToastContainer />
            <div class="rounded-t bg-white mb-0 px-6 py-6">
              <div class="text-center flex justify-between">
                <h6 class="text-blueGray-700 text-xl font-bold">{preInvoice?.id == '#'? "Crear" : "Actualizar"} Proformas</h6>
              </div>
            </div>
            <div className="flex-auto px-4 lg:px-10 py-10 pt-0 bg-white">
              <div className="w-full flex flex-wrap px-4 pt-4">
                <div className="w-full lg:w-3/12 px-0">
                  <h6 class="text-blueGray-400 text-sm mt-3 my-6 font-bold uppercase">Información de la Proformas</h6>
                </div>
                <div className="w-full lg:w-9/12 px-0 text-right space-y-1">
                {/* LÍNEA 1: Título + Fecha */}
                <div className="flex justify-end items-baseline gap-2">
                  <h6 className="text-blueGray-400 text-sm font-bold uppercase whitespace-nowrap">
                    {formatText("Tasa de cambio del día:")}
                  </h6>
                  <h6 className="text-blueGray-400 text-sm font-bold uppercase whitespace-nowrap">
                    {type != 'NC' ? (
                      formatDate(latestExchangeRateHistory.tasas['USD'].fecha_valor)
                    ):(
                      formatDate(preInvoice.tasa_bcv.fecha)
                    )}
                  </h6>
                </div>

                {/* LÍNEA 2: USD */}
                <div className="flex justify-end items-baseline gap-2 pr-0">
                  <span className="text-sm font-bold text-blueGray-600">USD</span>
                  <h6 className="text-lg font-black text-gray-800">
                    {type != 'NC' ? (
                      formatMoneySpecial(latestExchangeRateHistory.tasas['USD'].tasa, 4)
                    ):(
                      formatMoneySpecial(preInvoice.tasa_bcv.tasa_usd, 4)
                    )}
                  </h6>
                </div>

                {/* LÍNEA 3: EUR */}
                <div className="flex justify-end items-baseline gap-2 pr-0">
                  <span className="text-sm font-bold text-blueGray-600">EUR</span>
                  <h6 className="text-lg font-black text-gray-800">
                    {type != 'NC' ? (
                      formatMoneySpecial(latestExchangeRateHistory.tasas['EUR'].tasa, 4)
                    ):(
                      formatMoneySpecial(preInvoice.tasa_bcv.tasa_eur, 4)
                    )}
                  </h6>
                </div>
              </div>
                    {rol == 'admin' && (
                  <div className="relative lg:w-3/12 mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Empresa Afiliada (RIF)</label>
                      <input
                        type="text"
                        className="hidden border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.empresa_id}
                        placeholder="J-12345678-0"
                        onChange={(e) => setPreInvoice({ ...preInvoice, empresa_id: e.target.value })}
                      />
                      <div className="relative">
                        <Autocomplete
                            freeSolo
                            options={
                              showResults && preInvoice.cliente_rif !== ''
                                ? filterResultsAdmin ?? []
                                : clients ?? []}
                            getOptionLabel={(opt) =>
                              opt?.rif ? `${opt.rif} — ${opt.nombre_empresa}` : ""
                            }
                            filterOptions={(options) => options} // usamos tu propio filtro manual
                            value={null}
                            inputValue={preInvoice.cliente_rif || ""}
                            onInputChange={(e) => {
                              let value = e.target.value.toString().toUpperCase();
                              if (value == undefined){
                                value = '';
                              }
                              // Elimina caracteres no válidos (solo letras, números y guiones)
                              value = value.replace(/[^A-Z0-9-]/g, "");

                              // Forzar el patrón paso a paso
                              if (value.length === 1) {
                                // Primera posición → solo letras válidas
                                if (!/[VJEPGC123456789]/.test(value)) value = "";
                              } else if (value.length === 2) {
                                  // Solo agregar guion si comienza con letra válida
                                  if (/[VJEPGC]/.test(value[0]) && /[1234567890]/.test(value[1]) && !value.includes("-")) {
                                    if (/[VJEPGC1234567890-]/.test(value[1])){
                                      value = value[0] + "-" + value[1];
                                    }else{
                                      value = value[0];
                                    }
                                  }else if (!/[1234567890]/.test(value)) {
                                    value = value[0];
                                  }
                                } else if (value.length > 2) {
                                // Nuevo: permitir solo números (hasta 8)
                                const matchSoloNumeros = value.match(/^\d{0,8}$/);

                                if (matchSoloNumeros) {
                                  value = matchSoloNumeros[0];
                                } else {
                                  // Caso RIF tradicional
                                  const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);
                                  if (match) {
                                    const [, letra, numeros, verificador] = match;
                                    value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
                                  } else {
                                    value = preInvoice.cliente_rif;
                                  }
                                }
                              }

                              handleSearchRif(value, 'admin')
                            }}
                            onChange={(event, newValue) => {
                              if (newValue) selectClient(newValue, 'admin');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="V-12345678-0"
                                placeholder="V-12345678-0"
                                variant="outlined"
                                size="small"
                                onKeyDown={(e) => {
                                  // Si el usuario presiona Backspace
                                  if (e.key === "Backspace") {
                                    if (preInvoice.cliente_rif.substr(preInvoice.cliente_rif.length - 1, preInvoice.cliente_rif.length) == '-'){
                                      reduceRif(preInvoice.cliente_rif.substr(0, preInvoice.cliente_rif.length - 1), 'admin');
                                    }
                                  }
                                  // ENTER para seleccionar primer elemento si no se ha elegido uno
                                  if (e.key === "Enter") {
                                    if (filterResultsAdmin.length > 0) {
                                      e.preventDefault();
                                      selectClient(filterResultsAdmin[0], 'admin');
                                    }
                                  }
                                }}
                              />
                            )}
                          />
                      </div>
                  </div>
                )}
                {rol == 'admin' && (
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Razon Social</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.cliente_nombre} readonly="readonly"
                        placeholder="Nombre de la empresa afiliada"
                        onChange={(e) => setPreInvoice({ ...preInvoice, cliente_nombre: e.target.value.toString().toUpperCase() })}
                      />
                    </div>
                  </div>
                )}
                {/* (2026-05-13) Req1 P2e: bloque de Documento a Tercero.
                    Visible UNICAMENTE cuando el emisor (cliente del usuario o
                    cliente seleccionado por admin) tiene es_emisor=true. El
                    select de terceros aparece solo si doc_tercero esta activo. */}
                {clienteEmisorEsEmisor && preInvoice?.id == '#' && (
                  <div className="w-full px-4">
                    <div className="flex flex-wrap items-end">
                      <div className="w-full lg:w-3/12 px-0">
                        <div className="relative w-full mb-3 flex items-center gap-2 pt-6">
                          <input
                            id="doc_tercero"
                            type="checkbox"
                            className="h-4 w-4"
                            checked={!!preInvoice.doc_tercero}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setPreInvoice({
                                ...preInvoice,
                                doc_tercero: checked,
                                tercero_id: checked ? preInvoice.tercero_id : null,
                              });
                            }}
                          />
                          <label htmlFor="doc_tercero" className="text-blueGray-600 text-xs font-bold">
                            Documento a Tercero
                          </label>
                        </div>
                      </div>
                      {preInvoice.doc_tercero && (
                        <div className="w-full lg:w-9/12 px-0">
                          <div className="relative w-full mb-3">
                            <label className="block text-blueGray-600 text-xs font-bold mb-2">
                              Empresa Tercero <span className="text-red-500">*</span>
                            </label>
                            {/* (2026-08-02, ítem 29-i) Buscador: el <select>
                                nativo obligaba a recorrer la lista completa de
                                terceros del emisor. Autocomplete de MUI, mismo
                                patrón que FormWithholdings.js:803-824 (el
                                archivo ya importaba MUI). La lógica del onChange
                                —herencia de moneda designada y moneda extranjera
                                del tercero, y vuelta al emisor al deseleccionar—
                                se conserva ÍNTEGRA; lo único que cambia es la
                                fuente del id: antes `e.target.value` (string del
                                <option>), ahora el objeto del Autocomplete. */}
                            <Autocomplete
                              options={terceros || []}
                              size="small"
                              value={(terceros || []).find((t) => t.id === preInvoice.tercero_id) || null}
                              isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                              getOptionLabel={(opt) => (opt?.rif ? `${opt.rif} — ${opt.nombre_empresa}` : "")}
                              noOptionsText="No hay terceros disponibles"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Seleccione un tercero..."
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              onChange={(event, newValue) => {
                                const newTerceroId = newValue && newValue.id ? Number(newValue.id) : null;
                                // (2026-05-14) Al seleccionar un tercero, aplicar
                                // su moneda_designada (y su moneda_extranjera) como
                                // default de la proforma. Si se deselecciona, se
                                // intenta volver a la moneda_designada del emisor:
                                //   - admin: ya almacenada via selectClient.
                                //   - operador: viene del authData.
                                const terceroObj = (terceros || []).find((t) => t.id === newTerceroId);
                                let nextMonedaId = preInvoice.moneda_id;
                                let nextMonedaObj = preInvoice.moneda;
                                let nextMonedaExtCod = monedaExtranjeraCodigo;
                                if (terceroObj) {
                                  if (terceroObj.moneda_designada_id) {
                                    nextMonedaId = terceroObj.moneda_designada_id;
                                    nextMonedaObj = terceroObj.moneda_designada || null;
                                  }
                                  if (terceroObj.moneda_extranjera && terceroObj.moneda_extranjera.codigo) {
                                    nextMonedaExtCod = (terceroObj.moneda_extranjera.codigo || '').trim().toUpperCase();
                                  }
                                } else {
                                  // Volver al emisor: para operador usamos authData; para
                                  // admin, no recalculamos aqui (el selectClient ya lo hizo).
                                  if (rol !== 'admin' && authData) {
                                    try {
                                      const parsed = JSON.parse(authData);
                                      const cli = parsed['cliente'] || {};
                                      if (cli.moneda_designada_id) {
                                        nextMonedaId = cli.moneda_designada_id;
                                        nextMonedaObj = cli.moneda_designada || null;
                                      }
                                      if (cli.moneda_extranjera && cli.moneda_extranjera.codigo) {
                                        nextMonedaExtCod = (cli.moneda_extranjera.codigo || '').trim().toUpperCase();
                                      }
                                    } catch (_) { /* noop */ }
                                  }
                                }
                                setMonedaExtranjeraCodigo(nextMonedaExtCod);
                                setPreInvoice({
                                  ...preInvoice,
                                  tercero_id: newTerceroId,
                                  moneda_id: nextMonedaId,
                                  moneda: nextMonedaObj,
                                });
                              }}
                            />
                            {errors.tercero_id && <p className="text-red-500 text-xs mt-1">{errors.tercero_id}</p>}
                            {(terceros || []).length === 0 && (
                              <p className="text-xs text-orange-600 mt-1">
                                {/* (2026-05-14) Pista util: cuando el contrato
                                    del tercero no esta Aprobado, el tercero
                                    queda inactivo y no aparece aqui. */}
                                No hay clientes tercero activos vinculados a este emisor.
                                Verifique que el contrato del tercero esté en estado <strong>Aprobado</strong>;
                                de lo contrario el tercero permanece inactivo y no puede facturarse.
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
                <hr class="my-6 border-b-1 border-blueGray-300"/>
                <div className="flex flex-wrap">
                  {/* (2026-07-16 C9) Selector de Tipo de Venta (Catálogo 5).
                      Por defecto Interna ('01'); permite marcar exportaciones
                      (FOB/CIF/EXW). El backend emite este CÓDIGO en tipoDeVenta.
                      Solo editable al crear (id === '#'). */}
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Tipo de Venta
                      </label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 disabled:bg-gray-100"
                        value={preInvoice.tipo_venta || '01'}
                        disabled={preInvoice.id !== '#'}
                        onChange={(e) => setPreInvoice({ ...preInvoice, tipo_venta: e.target.value })}
                      >
                        {(tiposVenta || []).map((tv) => (
                          <option key={tv.codigo} value={tv.codigo}>
                            {tv.codigo} — {tv.valor}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* (2026-05-14) Selector de moneda de la proforma.
                      Lista catalogo activo de monedas (VES, USD, EUR, etc.).
                      Solo editable al crear (id === '#'). En edicion queda
                      read-only porque cambiar la moneda requiere re-cotizar
                      todos los items. El cambio dispara recalculo de precios
                      cuando el usuario selecciona productos nuevos; los items
                      ya cargados conservan el valor que el usuario fijo. */}
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Moneda de la {type == 'FC' ? 'factura' : (type == 'NC' ? 'Nota de Crédito' : 'Nota de Débito')}
                      </label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 disabled:bg-gray-100"
                        value={preInvoice.moneda_id || ''}
                        disabled={preInvoice.id !== '#'}
                        onChange={(e) => {
                          const newId = e.target.value ? parseInt(e.target.value, 10) : null;
                          const monedaObj = (monedas || []).find((m) => m.id === newId) || null;
                          setPreInvoice({ ...preInvoice, moneda_id: newId, moneda: monedaObj });
                        }}
                      >
                        <option value="">— Seleccione —</option>
                        {(monedas || []).map((m) => (
                          <option key={m.id} value={m.id}>
                            {m.codigo} — {m.nombre} ({m.simbolo})
                          </option>
                        ))}
                      </select>
                      {monedaExtranjeraCodigo && preInvoice.moneda?.codigo &&
                        (preInvoice.moneda.codigo || '').toUpperCase() !== monedaExtranjeraCodigo && (
                          <p className="text-xs text-blueGray-400 mt-1">
                            Precios de productos en {monedaExtranjeraCodigo}; se convierten a {preInvoice.moneda.codigo} con tasa BCV.
                          </p>
                        )}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Fecha de {type == 'FC' ? 'factura' : (type == 'NC' ? 'la Nota de Crédito' : 'la Nota de Débito')}</label>
                      <input
                        type="date"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.fecha_factura} max={formattedDate}
                        placeholder="dd/mm/yyyy"
                        onChange={(e) => setPreInvoice({ ...preInvoice, fecha_factura: e.target.value })}
                      />
                      {errors.fecha_factura && <p className="text-red-500 text-xs mt-1">{errors.fecha_factura}</p>}
                    </div>
                  </div>
                  {/* (2026-07-08) Fecha de vencimiento OPCIONAL (vacío = contado).
                      Espeja el patrón de fecha_factura (mismo binding a preInvoice,
                      mismas clases). Sin `max={formattedDate}` porque el vencimiento
                      puede ser posterior a hoy. No se valida (campo opcional): un
                      valor vacío no bloquea el submit. `|| ""` evita input no
                      controlado en documentos cargados que no traen la clave. */}
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Fecha de Vencimiento</label>
                      <input
                        type="date"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.fecha_vencimiento || ""}
                        placeholder="dd/mm/yyyy"
                        // (2026-08-02, ítem 34) `min` = fecha del documento: el
                        // propio control impide elegir una fecha anterior; la
                        // validación de validate() es la red que sí manda.
                        min={preInvoice.fecha_factura || undefined}
                        onChange={(e) => setPreInvoice({ ...preInvoice, fecha_vencimiento: e.target.value })}
                      />
                      {errors.fecha_vencimiento && <p className="text-red-500 text-xs mt-1">{errors.fecha_vencimiento}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">RIF</label>
                      <input
                        type="text"
                        className="hidden border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.cliente_id}
                        placeholder="J-12345678-0"
                        onChange={(e) => setPreInvoice({ ...preInvoice, cliente_id: e.target.value })}
                      />
                      <div className="relative">
                        <Autocomplete
                          freeSolo
                          options={showResults && preInvoice.cliente_rif !== '' ? filterResults ?? [] : endClients ?? []}
                          getOptionLabel={(opt) => opt?.rif ? `${opt.rif} — ${opt.nombre}` : ""}
                          filterOptions={(options) => options} // Desactiva filtro automático
                          value={null}
                          inputValue={preInvoice.cliente_rif || ""}
                          disabled={type != 'FC' ? true : false}
                          onInputChange={(e, value) => handleSearchRif(value, 'client')}
                          onChange={(event, newValue) => {
                            if (newValue) selectClient(newValue, 'client');
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="V-12345678-0"
                              placeholder="V-12345678-0"
                              variant="outlined"
                              size="small"
                              onKeyDown={(e) => {
                                // 🔑 ENTER: Selecciona el PRIMER elemento si hay resultados
                                if (e.key === "Enter") {
                                  e.preventDefault(); // ← EVITA submit del form
                                  e.stopPropagation(); // ← EVITA bubbling

                                  if (filterResults.length > 0) {
                                    selectClient(filterResults[0], 'client'); // ← SELECCIONA PRIMERO
                                  }
                                  setTimeout(() => {
                                    const correlativoInput = document.querySelector('input[name="correlativo_interno"]');

                                    if (correlativoInput) {
                                      correlativoInput.focus();
                                    }
                                  }, 100);
                                  return false;
                                }

                                // Backspace para guiones
                                if (e.key === "Backspace") {
                                  if (preInvoice.cliente_rif.endsWith('-')) {
                                    const newRif = preInvoice.cliente_rif.slice(0, -1);
                                    reduceRif(newRif, 'client');
                                  }
                                }
                              }}
                              onChange={(e) => {
                                let value = e.target.value.toUpperCase();
                                if (value == undefined){
                                  value = '';
                                }
                                // Elimina caracteres no válidos (solo letras, números y guiones)
                                value = value.replace(/[^A-Z0-9-]/g, "");

                                // Forzar el patrón paso a paso
                                if (value.length === 1) {
                                  // Primera posición → solo letras válidas
                                  if (!/[VJEPGC123456789]/.test(value)) value = "";
                                } else if (value.length === 2) {
                                    // Solo agregar guion si comienza con letra válida
                                    if (/[VJEPGC]/.test(value[0]) && !value.includes("-")) {
                                      if (/[VJEPGC123456789-]/.test(value[1])){
                                        value = value[0] + "-" + value[1];
                                      }else{
                                        value = value[0];
                                      }
                                    }
                                  } else if (value.length > 2) {
                                  // Nuevo: permitir solo números (hasta 8)
                                  const matchSoloNumeros = value.match(/^\d{0,8}$/);

                                  if (matchSoloNumeros) {
                                    value = matchSoloNumeros[0];
                                  } else {
                                    // Caso RIF tradicional
                                    const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);
                                    if (match) {
                                      const [, letra, numeros, verificador] = match;
                                      value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
                                    } else {
                                      value = preInvoice.cliente_rif;
                                    }
                                  }
                                }

                                setPreInvoice({ ...preInvoice, cliente_rif: value });
                              }}
                            />
                          )}
                        />

                        {/*
                        {showResults && filterResults.length > 0 && (
                          <ul className="absolute z-50 bg-white border border-gray-300 rounded w-full mt-1 max-h-48 overflow-y-auto shadow-lg ul_search_client">
                            {filterResults.map((c) => (
                              <li
                                key={c.id}
                                className="px-3 py-2 hover:bg-gray-200 cursor-pointer li_search_client"
                                onClick={() => selectClient(c)}
                              >
                                <strong>{c.rif}</strong> — {c.nombre}
                              </li>
                            ))}
                          </ul>
                        )}

                        {showResults && filterResults.length === 0 && (
                          <div id="div_none_endclients" className="absolute z-50 bg-white border border-gray-300 rounded w-full mt-1 px-3 py-2 text-gray-500">
                            No se encontraron resultados, se creara un nuevo cliente con los datos enviados.
                          </div>
                        )}*/}
                      </div>
                      {errors.cliente_rif && <p className="text-red-500 text-xs mt-1">{errors.cliente_rif}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-8/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Razon Social</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.cliente_nombre}
                        placeholder="Nombre de la empresa" disabled={type != 'FC' ? true : false}
                        onChange={(e) => setPreInvoice({ ...preInvoice, cliente_nombre: e.target.value.toString().toUpperCase() })}
                      />
                    </div>
                    {errors.cliente_nombre && <p className="text-red-500 text-xs mt-1">{errors.cliente_nombre}</p>}
                  </div>
                  <div className="w-full lg:w-2/12 px-4 form-client-complement">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Telefono</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.cliente_telefono} disabled={type != 'FC' ? true : false}
                        placeholder="0000-0000000"
                        onChange={(e) => {
                          let value = e.target.value;
                          // Eliminar todo lo que no sea número
                          value = value.replace(/\D/g, "");

                          // Limitar a máximo 11 dígitos (4 + 7)
                          value = value.slice(0, 11);

                          // Insertar guion después de los primeros 4 dígitos
                          if (value.length > 4) {
                            value = value.slice(0, 4) + "-" + value.slice(4);
                          }
                          setPreInvoice({ ...preInvoice, cliente_telefono: value });
                        }}
                      />
                      {errors.cliente_telefono && <p className="text-red-500 text-xs mt-1">{errors.cliente_telefono}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-4/12 px-4 form-client-complement">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Correo electronico</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.cliente_email} disabled={type != 'FC' ? true : false}
                        placeholder="correo@correo.com"
                        onChange={(e) => setPreInvoice({ ...preInvoice, cliente_email: e.target.value.toString().toUpperCase() })}
                      />
                      {errors.cliente_email && <p className="text-red-500 text-xs mt-1">{errors.cliente_email}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4 form-client-complement">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Dirección</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.cliente_direccion} disabled={type != 'FC' ? true : false}
                        placeholder="Calle, Avenida, Torre y/o Edificio"
                        onChange={(e) => setPreInvoice({ ...preInvoice, cliente_direccion: e.target.value.toString().toUpperCase() })}
                      />
                      {errors.cliente_direccion && <p className="text-red-500 text-xs mt-1">{errors.cliente_direccion}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-3">Tipo de documento</label>
                      <label className="block text-blueGray-600 text-xs mt-0 font-bold">{preInvoice.tipo_documento == 'FC' ?
                        ('FACTURA')
                        :
                        (preInvoice.tipo_documento == 'NC'?
                          ('NOTA DE CREDITO')
                          :
                          ('NOTA DE DEBITO')
                        )
                      }</label>
                      <label className="block text-blueGray-600 text-xs mt-2 font-bold">{preInvoice.tipo_documento != 'FC' &&
                        ('Fecha de emisión de la factura: '+ formatDate(preInvoice.fecha_factura_old))
                      }</label>
                      <label className="block text-blueGray-600 text-xs mt-2 font-bold">{preInvoice.tipo_documento != 'FC' &&
                        ('N° de factura afectada: '+ formatText(preInvoice.numero_factura))
                      }</label>
                      <input
                        type="text"
                        className="hidden border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.tipo_documento}
                      />
                      {/*<select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.tipo_documento} readonly
                        onChange={(e) => setClient({ ...preInvoice, tipo_documento: e.target.value })}>
                        <option value="#">Seleccione...</option>
                        <option value="FC">Factura</option>
                        <option value="NC">Nota de Crédito</option>
                        <option value="ND">Nota de Débito</option>
                      </select>*/}
                    </div>
                  </div>
                  {/* (2026-08-02, ítem 29-ii) Correlativo Interno: SOLO en modo
                      ValidacionDocumento (o con el modo del emisor desconocido).
                      En NumeracionAutomatica el consecutivo lo asigna el sistema
                      y el campo no se pide ni se valida; el payload envía NULL.
                      En su lugar se deja una leyenda para que el operador sepa
                      por qué no está el campo (un hueco silencioso se lee como
                      un error de la pantalla). */}
                  {!correlativoAutomatico ? (
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Correlativo Interno</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.correlativo_interno || ""}
                        placeholder="0000..."
                        name="correlativo_interno"
                        onChange={(e) => setPreInvoice({ ...preInvoice, correlativo_interno: e.target.value.toString().toUpperCase() })}
                      />
                      {errors.correlativo_interno && <p className="text-red-500 text-xs mt-1">{errors.correlativo_interno}</p>}
                    </div>
                  </div>
                  ) : (
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Correlativo Interno</label>
                      <p className="text-xs text-blueGray-400 mt-2">
                        <i className="fas fa-circle-info mr-1" aria-hidden="true" />
                        La empresa emisora opera en <strong>Numeración Automática</strong>:
                        el consecutivo lo asigna el sistema.
                      </p>
                    </div>
                  </div>
                  )}
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Zona</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={preInvoice.zona} disabled={type != 'FC' ? true : false}
                        placeholder="Ciudad"
                        onChange={(e) => setPreInvoice({ ...preInvoice, zona: e.target.value.toString().toUpperCase() })}
                      />
                      {errors.zona && <p className="text-red-500 text-xs mt-1">{errors.zona}</p>}
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap">
                  {/* Aquí el grupo de radio buttons */}

                    {type == 'ND' && (
                      <div className="w-full lg:w-12/12 px-4 mt-1 text-center">
                        <hr class="my-6 border-b-1 border-blueGray-300"/>
                        <Tabs value={tab} onChange={(e, v) => setTab(v)} textColor="primary" indicatorColor="primary" centered>
                          <Tab value="productos" label="Productos/Servicios" />
                          <Tab value="conceptos" label="Conceptos" />
                        </Tabs>
                      </div>
                    )}
                    {/* Condicionalmente renderizamos los DataGrids basados en el estado selectedView */}
                    {tab === "productos" && (
                      <div className="w-full lg:w-12/12 px-4 mt-1 text-right">
                        {type != 'NC' && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleAddRow}
                          style={{ marginBottom: 10 }}>
                          Agregar línea
                        </Button>
                        )}
                        <DataGrid
                          apiRef={apiRef}
                          rows={preInvoice.items}
                          columns={columns}
                          getRowId={(row) => row.id}
                          pageSize={5}
                          autoHeight
                          processRowUpdate={processRowUpdate}
                          // (2026-08-02, ítem 30-ii) La columna de descuento que
                          // NO aplica al tipo elegido en esa fila tampoco se
                          // puede editar: sin esto el usuario podía escribir un
                          // porcentaje en una línea de monto fijo y verlo
                          // desaparecer al confirmar (processRowUpdate lo limpia
                          // para respetar la exclusividad del backend).
                          isCellEditable={(params) => {
                            if (params.field === 'descuento_porcentaje') {
                              return tipoDescuentoLinea(params.row) !== 'monto';
                            }
                            if (params.field === 'descuento_monto') {
                              return tipoDescuentoLinea(params.row) === 'monto';
                            }
                            return true;
                          }}
                          columnVisibilityModel={{
                            id: false, // oculta la columna "id"
                            nueva_linea: false, // oculta la columna "nueva_linea"
                            iva_categoria_id: false, // oculta la columna "iva_categoria_id"
                          }}
                          rowHeight={30}
                          localeText={esES.components.MuiDataGrid.defaultProps.localeText} // Traducción al español
                          sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                              fontWeight: 'bold',   // ahora sí en negrita
                              fontSize: '0.80rem',
                            },
                          }}
                        />
                      </div>
                    )}
                    {tab === "conceptos" && (
                      <div className="w-full lg:w-12/12 px-4 mt-5 text-right">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleAddRowNd}
                          style={{ marginBottom: 10 }}>
                          Agregar concepto
                        </Button>
                        <DataGrid
                          apiRef={apiRefNd}
                          rows={preInvoice.conceptos_nd}
                          columns={columnsNd}
                          getRowId={(row) => row.id}
                          pageSize={5}
                          autoHeight
                          processRowUpdate={processRowUpdateNd}
                          columnVisibilityModel={{
                            id: false, // oculta la columna "id"
                            nueva_linea: false, // oculta la columna "nueva_linea"
                          }}
                          rowHeight={30}
                          localeText={esES.components.MuiDataGrid.defaultProps.localeText} // Traducción al español
                          sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                              fontWeight: 'bold',   // ahora sí en negrita
                              fontSize: '0.80rem',
                            },
                          }}
                        />
                      </div>
                    )}
                  <div className="w-full lg:w-12/12 px-5 my-1 text-center">
                    {errors.items &&
                      <p className="text-red-500 text-xs mt-1">
                        {errors.items.map(item => (
                          <span className="text-start">{item}<br/></span>
                        ))}
                    </p>}
                  </div>
                  <div className="flex w-full lg:w-8/12 px-4 ml-0 lg:ml-4 pb-3 flex-1 min-w-0 border border-gray-200 rounded-lg shadow-sm">
                    <div className="w-full lg:w-9/12 px-1 mt-3 pl-0">
                      <div className="relative w-full mb-3 text-end">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAddRowMp}
                            style={{ marginBottom: 10 }}>
                            Agregar pago
                          </Button>
                        <DataGrid
                          apiRef={apiRefMp}
                          rows={preInvoice.pagos || []}
                          columns={columnsMp}
                          getRowId={(row) => row.id}
                          pageSize={5}
                          autoHeight
                          processRowUpdate={processRowUpdateMp}
                          onProcessRowUpdateError={(error) => {
                            console.error('Error updating payment row:', error);
                            toast.error('Error al actualizar pago');
                          }}
                          // ← EVENTOS SIMPLIFICADOS Y CORREGIDOS
                          onCellClick={(params, event) => {
                            // Solo intervenir si es la columna 'banco'
                            if (params.field === 'banco') {
                              const metodoPago = paymentMethods?.find(p => p.codigo === params.row.metodo_pago_codigo);

                              // Si aplica IGTF → bloquear completamente
                              if (metodoPago?.aplica_igtf) {
                                event.stopPropagation();
                                event.preventDefault();
                                return;
                              }

                              // Si NO aplica IGTF → dejar que MUI maneje la edición normal
                              // NO forzar startCellEditMode aquí
                            }
                          }}
                          columnVisibilityModel={{
                            id: false,
                            nueva_linea: false,
                            aplica_igtf: false,
                            // (2026-05-14) tasa_actual oculta — solo usada por
                            // validate() para convertir pagos multi-moneda.
                            tasa_actual: false,
                          }}
                          rowHeight={30}
                          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                          sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                              fontWeight: 'bold',
                              fontSize: '0.80rem',
                            },
                          }}
                        />
                        <div className="w-full lg:w-12/12 px-5 my-1 text-center">
                          {errors.pagos &&
                            <p className="text-red-500 text-xs mt-1">
                              {errors.pagos.map(pago => (
                                <span className="text-start">{pago}<br/></span>
                              ))}
                          </p>}
                        </div>
                      </div>
                    </div>
                    <div className="w-full lg:w-3/12 px-1 pr-0 pt-1 pb-1 mt-10">
                      {/* CONTENEDOR PRINCIPAL con bordes redondeados */}
                      <div className="apply_igtf mt-3 border border-gray-200 rounded-lg shadow-sm bg-gray-50 hidden">
                        {/* FILA 1: Total pagado */}
                        <div className="p-4 pb-2 border-b border-gray-200">
                          <label className="block text-blueGray-600 text-xs font-bold mb-2">
                            Total pagado en divisas
                          </label>
                        </div>

                        {/* VALOR 1: Monto (2026-05-14: moneda de la proforma) */}
                        <div className="p-4 pt-0 text-right border-b border-gray-200">
                          <label className="border-0 px-3 text-blueGray-600 rounded text-lg font-bold">
                            {formatMoney(preInvoice.monto_pagado_divisas, preInvoice.moneda)}
                          </label>
                        </div>

                        {/* FILA 2: IGTF */}
                        <div className="p-4 pb-2 border-b border-gray-200">
                          <label className="block text-blueGray-600 text-xs font-bold mb-2">
                            {'IGTF ' + formatDecimal(preInvoice.igtf_porcentaje) + '%' }
                          </label>
                        </div>

                        {/* VALOR 2: Monto IGTF (2026-05-14: moneda de la proforma) */}
                        <div className="p-4 pt-0 text-right">
                          <label className="border-0 px-3 text-blueGray-600 rounded text-lg font-bold">
                            {formatMoney(igtfAmount, preInvoice.moneda)}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* (2026-05-14) Totales formateados con la moneda de la
                      proforma. formatMoney acepta el objeto `moneda` (codigo,
                      simbolo, posicion) como segundo argumento. */}
                  <div className="w-full lg:w-4/12 px-4 mt-3">
                    {/* (2026-07-20 Recargos) Recargos GLOBALES del documento
                        {descripcion, monto}. Se prorratean sobre las bases en el
                        backend (factor = 1 + R/SAD). UpperCase en la descripción. */}
                    <div className="w-full mb-3">
                      <div className="flex items-center justify-between mb-1">
                        <label className="block text-blueGray-600 font-bold text-lg">Recargos</label>
                        {type != 'NC' && (
                          <button type="button" onClick={addRecargoGlobal}
                            className="text-sm bg-slate-800 text-white rounded px-2 py-1">
                            <i className="fa-solid fa-plus me-1"></i>Agregar
                          </button>
                        )}
                      </div>
                      {(preInvoice.recargos_globales || []).map((rg, idx) => (
                        <div key={idx} className="flex w-full mb-1 gap-1 items-center">
                          <input type="text" placeholder="DESCRIPCIÓN"
                            value={rg.descripcion || ''}
                            disabled={type == 'NC'}
                            onChange={(e) => updateRecargoGlobal(idx, 'descripcion', e.target.value)}
                            className="border rounded px-2 py-1 text-sm w-7/12" />
                          <input type="number" step="0.01" min="0" placeholder="0,00"
                            value={rg.monto ?? 0}
                            disabled={type == 'NC'}
                            onChange={(e) => updateRecargoGlobal(idx, 'monto', e.target.value)}
                            className="border rounded px-2 py-1 text-sm w-4/12 text-right" />
                          <button type="button" onClick={() => removeRecargoGlobal(idx)}
                            className="text-red-600 px-1" title="Quitar recargo">
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      ))}
                      {recargosGlobalTotal > 0 && (
                        <div className="flex w-full mt-1 justify-end">
                          <label className="text-blueGray-600 font-bold text-md pr-1">
                            Total recargos: {formatMoney(recargosGlobalTotal, preInvoice.moneda)}
                          </label>
                        </div>
                      )}
                    </div>
                    {/* (2026-08-03 P3) Descuentos GLOBALES del documento
                        {descripcion, monto}. ESPEJO EXACTO de la sección de
                        recargos de arriba, con la proporción INVERSA: el backend
                        los prorratea con el factor combinado
                        (1 − D/SAD)(1 + R/SAD). UpperCase en la descripción.
                        Deshabilitada en NC, igual que los recargos. */}
                    <div className="w-full mb-3">
                      <div className="flex items-center justify-between mb-1">
                        <label className="block text-blueGray-600 font-bold text-lg">Descuentos</label>
                        {type != 'NC' && (
                          <button type="button" onClick={addDescuentoGlobal}
                            className="text-sm bg-slate-800 text-white rounded px-2 py-1">
                            <i className="fa-solid fa-plus me-1"></i>Agregar
                          </button>
                        )}
                      </div>
                      {(preInvoice.descuentos_globales || []).map((dg, idx) => (
                        <div key={idx} className="flex w-full mb-1 gap-1 items-center">
                          <input type="text" placeholder="DESCRIPCIÓN"
                            value={dg.descripcion || ''}
                            disabled={type == 'NC'}
                            onChange={(e) => updateDescuentoGlobal(idx, 'descripcion', e.target.value)}
                            className="border rounded px-2 py-1 text-sm w-7/12" />
                          <input type="number" step="0.01" min="0" placeholder="0,00"
                            value={dg.monto ?? 0}
                            disabled={type == 'NC'}
                            onChange={(e) => updateDescuentoGlobal(idx, 'monto', e.target.value)}
                            className="border rounded px-2 py-1 text-sm w-4/12 text-right" />
                          <button type="button" onClick={() => removeDescuentoGlobal(idx)}
                            className="text-red-600 px-1" title="Quitar descuento">
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      ))}
                      {descuentosGlobalTotal > 0 && (
                        <div className="flex w-full mt-1 justify-end">
                          <label className="text-blueGray-600 font-bold text-md pr-1">
                            Total descuentos: {formatMoney(descuentosGlobalTotal, preInvoice.moneda)}
                          </label>
                        </div>
                      )}
                    </div>
                    <div className="flex w-full mb-1">
                      <div className="w-full lg:w-5/12 px-4 mt-3">
                        <label className="block text-blueGray-600 font-bold text-lg">Base imponible</label>
                      </div>
                      <div className="w-full lg:w-7/12 px-4 mt-3 text-right pr-0">
                        <label className="text-right border-0 px-3 text-blueGray-600 bg-white rounded text-lg font-bold pr-1">
                        {formatMoney(taxBase, preInvoice.moneda)}
                        </label>
                      </div>
                    </div>
                    <div className="flex w-full mb-1">
                      <div className="w-full lg:w-4/12 px-4">
                        <label className="block text-blueGray-600 font-bold text-lg">I.V.A.</label>
                      </div>
                      <div className="w-full lg:w-8/12 px-4 text-right pr-0">
                        <label className="text-right border-0 px-3 text-blueGray-600 bg-white rounded text-lg font-bold pr-1">
                        {formatMoney(taxApplied, preInvoice.moneda)}
                        </label>
                      </div>
                    </div>
                    <div className="flex w-full mb-3">
                      <div className="w-full lg:w-4/12 px-4">
                        <label className="block text-blueGray-600 font-bold text-lg">Total</label>
                      </div>
                      <div className="w-full lg:w-8/12 px-4 text-right pr-0">
                        <label className="text-right border-0 px-3 text-blueGray-600 bg-white rounded text-lg font-bold pr-1">
                        {formatMoney(totalAmount, preInvoice.moneda)}
                        </label>
                      </div>
                    </div>
                    {(preInvoice.monto_pagado_divisas > 0.0) ?
                    (<div className="flex w-full mb-3">
                        <div className="w-full lg:w-4/12 px-4">
                          <label className="block text-blueGray-600 font-bold text-lg">Total + IGTF</label>
                        </div>
                        <div className="w-full lg:w-8/12 px-4 text-right pr-0">
                          <label className="text-right border-0 px-3 text-blueGray-600 bg-white rounded text-lg font-bold pr-1 ">
                          {formatMoney(totalAmount + igtfAmount, preInvoice.moneda)}
                          </label>
                        </div>
                      </div>)
                      :
                      (<div className="hidden flex w-full mb-3">
                        <div className="w-full lg:w-3/12 px-4">
                        </div>
                        <div className="w-full lg:w-9/12 px-4 text-right">
                        </div>
                      </div>)
                    }
                  </div>
                </div>

                {/* ── (2026-07-22 Viajes) Nodo `/viajes` — agencias de viaje ──
                    D3: la sección SOLO existe si la empresa emisora tiene
                    `es_agencia_viajes` activo (o si el documento ya trae datos
                    de viaje). Para el resto de las empresas el formulario queda
                    exactamente igual que hoy y la UI no puede provocar el 400
                    del backend.
                    D2: sección repetible EN LÍNEA con botón «Agregar boleto»,
                    mismo patrón que ítems / pagos / recargos. Colapsable porque
                    son 15 campos por boleto. */}
                {mostrarSeccionViajes && (
                  <div className="w-full px-4 mt-4">
                    <div className="border border-twilight-indigo-200 rounded-lg overflow-hidden">
                      {/* Cabecera del acordeón */}
                      <button
                        type="button"
                        onClick={() => setViajesAbierto(!viajesAbierto)}
                        aria-expanded={viajesAbierto}
                        className="w-full flex items-center justify-between px-4 py-3 text-left bg-twilight-indigo-50 hover:bg-twilight-indigo-100 transition-colors"
                      >
                        <span className="flex items-center gap-2 min-w-0">
                          <i className="fas fa-plane-departure text-twilight-indigo-600" aria-hidden="true" />
                          <span className="text-twilight-indigo-700 text-xs uppercase font-bold">
                            Datos del Viaje (Boletería Aérea)
                          </span>
                          {(preInvoice.viajes || []).length > 0 && (
                            <span className="bg-twilight-indigo-600 text-white py-0.5 px-2 rounded-full text-[10px] font-bold">
                              {(preInvoice.viajes || []).length} boleto{(preInvoice.viajes || []).length === 1 ? '' : 's'}
                            </span>
                          )}
                        </span>
                        <i
                          className={`fas fa-chevron-down text-xs text-twilight-indigo-500 transition-transform duration-200 ${viajesAbierto ? 'rotate-180' : ''}`}
                          aria-hidden="true"
                        />
                      </button>

                      {viajesAbierto && (
                        <div className="bg-white border-t border-twilight-indigo-200 px-4 py-4">
                          {/* D1 nivel 2: marca POR DOCUMENTO. Al activarla, los
                              15 campos de cada boleto pasan a ser obligatorios
                              (regla del backend replicada en validate()). */}
                          <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                            <label className="inline-flex items-center text-sm">
                              <input
                                id="es_boleteria_aerea"
                                type="checkbox"
                                className="form-checkbox mr-2"
                                checked={!!preInvoice.es_boleteria_aerea}
                                onChange={(e) => setPreInvoice({
                                  ...preInvoice,
                                  es_boleteria_aerea: e.target.checked,
                                })}
                              />
                              <span className="font-bold text-blueGray-600">Este documento es boletería aérea</span>
                              <span className="ml-1 text-xs text-slate-500">
                                (exige los 15 datos en cada boleto)
                              </span>
                            </label>
                            <button
                              type="button"
                              onClick={addViaje}
                              className="text-sm bg-slate-800 text-white rounded px-2 py-1"
                            >
                              <i className="fa-solid fa-plus me-1"></i>Agregar boleto
                            </button>
                          </div>

                          {(preInvoice.viajes || []).length === 0 && (
                            <p className="text-xs text-slate-500 italic">
                              No hay boletos cargados. Use «Agregar boleto» para registrar los
                              datos del pasajero y del vuelo. Un mismo documento puede cubrir
                              varios boletos.
                            </p>
                          )}

                          {(preInvoice.viajes || []).map((viaje, idx) => (
                            <div key={idx} className="border border-slate-200 rounded-lg p-3 mb-3 bg-slate-50/60">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-blueGray-600 text-xs font-bold uppercase">
                                  Boleto #{idx + 1}
                                </span>
                                <button
                                  type="button"
                                  onClick={() => removeViaje(idx)}
                                  className="text-red-600 px-1"
                                  title="Quitar boleto"
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              </div>
                              <div className="flex flex-wrap -mx-2">
                                {VIAJE_CAMPOS.map((campo) => (
                                  <div key={campo.key} className={`w-full ${campo.ancho} px-2`}>
                                    <div className="relative w-full mb-3">
                                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                                        {campo.label}
                                        {preInvoice.es_boleteria_aerea && (
                                          <span className="text-red-500"> *</span>
                                        )}
                                      </label>
                                      <input
                                        type="text"
                                        maxLength={campo.max}
                                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={viaje[campo.key] || ''}
                                        placeholder={campo.hint}
                                        onChange={(e) => updateViaje(idx, campo.key, e.target.value)}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}

                          <div className="w-full my-1 text-center">
                            {errors.viajes &&
                              <p className="text-red-500 text-xs mt-1">
                                {errors.viajes.map(msg => (
                                  <span className="text-start">{msg}<br/></span>
                                ))}
                              </p>}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* ── Fin Viajes ── */}

                <div className={FORM_FOOTER_CONTAINER}>
                  <button
                    type="button"
                    className={FORM_BTN_CANCEL}
                    disabled={buttonDisabled}
                    onClick={() => redirectToList()}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className={FORM_BTN_SUBMIT}
                    disabled={buttonDisabled}
                  >
                    {buttonDisabled ? "Actualizando..." : preInvoice?.id == '#' ? "Guardar" : "Actualizar"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormProformas;